import { Component } from 'src/utils';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import cardLogo from './../../../images/credit-card-icon-support.png';
import template from './card-detail.html';
import paypalMonoIcon from './../../../images/paypal-monogram.png';
import cardUpdate from './../cards-management/card-update';

@Component({
  controllerAs: 'cardDetail',
  template
})

export default class CardDetail {
  static $inject = [
    '$scope',
    '$ngRedux',
    '$state',
    'toaster',
    '$stateParams',
    'spinnerService',
    'orderService',
    'authService',
    '$window', 'APP', '$q',
    '$uibModal',
    'Heartland',
    'GlobalPayments'
  ];

  constructor($scope, $ngRedux, $state, $toaster, $stateParams, $spinner, $order, $auth, $window, APP, $q, $uibModal, Heartland, GlobalPayments) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    var $main = this;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$order = $order;
    this.$toaster = $toaster;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.paypalMonoIcon = paypalMonoIcon;
    this.cardLogo = cardLogo;
    console.log("This cardlog -- ", this.cardLogo);
    this.$window = $window;
    this.$auth = $auth;
    this.APP = APP;
    this.$q = $q;
    this.$uibModal = $uibModal;
    this.$spinner = $spinner;
    this.isAllowedToAdd = true;
    this.isAllowedToRemove = true;
    this.isAllowToPayOnlyWithGiftCards = false;
    this.giftCardNumbers = [];
    this.totalGiftAmount = 0.00;
    this.waitUntilVerify = false;
    this.cardNumberRegEx = "/^[0-9]{1,5}$/";
    this.isMiscelleneousCategory = 4;
    this.showHeartLandPage = false;
    this.heartand_Approval = "APPROVAL";
    this.isErplyStore = false;
    this.allowErplyZeroDollarTrasaction = false;
    this.isStoreCreditUsed = false;
    this.isAllowToPayWithStoreCreditOnly = false;
    this.amountToBeChargedFromStoreCredit = 0.00;
    this.storeCreditAmount = 0.00;
    this.hasErplyCardUpdateInitialized = false;
    this.showAddCardButton = true;
    this.Heartland = Heartland;
    this.GlobalPayments = GlobalPayments;
    this.hasCardInitializedAlready = false;
    this.showPlaceOrderButton = false;
    this.payWithNewCardButton = false;
    this.payWithSavedCardButton = false;
    this.payWithPayPalButton = false;
    this.miscellaneous = "miscellaneous";
    this.addMiscellaneousPaymentMethod = false;
    this.showSavedCard = false;
    this.agreement = true;
    
    
    let promise1 = $order.getCartDetail(false);
    let promise2 = this.$order.getStoreFeatures();
    this.toDecimalPlaces = 2;
    this.isPaypalAuthorized = false;
    this.paymentMethod = {
      "creditCard": {
        "savedCard": "savedCard",
        "newCard": "newCard"
      },
      "paypal": {
        "payNow": "payNow",
        "payLater": "payLater",
        "payVault": "payVault"
      },
      "giftCard": "giftCard",
      "storeCredit": "storeCredit",
      "miscellaneous": this.miscellaneous
    };

    this.paymentMethods = [
      {
        "value": "newCard",
        "name": "Pay with debit or credit card",
        "logo": false,
        "cardLogo": true,
        "id": "newcard-pay-now",
        "lastChoosen": false,
        "type": "unique",
        "disable": false,
        "order": 1
      }
      // {"value":"payLater",
      //    "name":"Pay with Pay Later",
      //    "logo": true,
      //    "id" : "paypal-later-btn-marks"
      // },

    ];

    this.paymentMethods[0].lastChoosen = true;
    this.paymentOption = this.paymentMethods[0].value;
    this.payWithNewCardButton = true;

    this.paypalAutorizationWrapper = {
      "showPaypal": true,
      "isPaypalAuthorized": false,
      "authorizedAmount": 0.00,
      "authId": null
    };


    $spinner.show('appSpinner');
    $order.isGiveXAvailable()
      .then(success => {
        this.isGiveXAvailable = success.data.givexAvaible;
      })
      .catch(err => {
        this.isGiveXAvailable = false;
        this.$auth.printCustomerGenericLogs(err);
      })
      .finally(() => { });

    let promise3 = $auth.isGuestLogin() ? $auth.getGuestUserProfile() : $auth.getUserProfile();
    if (!$auth.isGuestLogin()) {
      $order.getPaymentInfo()
        .then(success => {
          if (success.data.length > 0) {
            this.cardId = success.data[0].id;
          }
        })
        .catch(err => {
          this.$auth.printCustomerGenericLogs(err);
        })
        .finally(() => {
        }
        );
    }
    $order.getOrderAmount(this.$stateParams.orderId)
      .then(success => {
        this.orderAmount = success.data;
      }).catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      });

    $order.getPaymentKeys().then(success => {
      this.paymentType = success.data.paymentType;
      this.paymentGlobalKey = success.data.globalKey;
      this.isErplyStore = success.data.isErplyStore;
      this.version = success.data.version;
      this.uuid = success.data.uuid;
      this.gatewayUrl = success.data.url;
      this.env = success.data.enviroment;
      if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.heartLand) {
        // Console.log("Print here something to indicate heartland");
      } else if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.tsys) {
        this.env = success.data.enviroment;
        // Console.log("Print here something to indicate heartland");
      } else if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.moneris) {
        // Console.log("Print here something to indicate heartland");
      }
    })
      .catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      });

    let promises = [promise1, promise3, promise2];
    $q.all(promises)
      .then(() => {
        console.log("this.storeFeatures.paypal",this.storeFeatures.paypal);
        if (this.storeFeatures.paypal.hasEnabledForCustomer) {
          var head = document.getElementsByTagName('head')[0];
          var script = document.createElement('script');
          var clientId = this.storeFeatures.paypal.clientId;
          var country = this.storeFeatures.paypal.countryCode;
          var merchantId = this.storeFeatures.paypal.merchantId;
          var currency = this.storeFeatures.paypal.currency;
          
          var source = "https://www.paypal.com/sdk/js?client-id=" + clientId
            + "&merchant-id="+ merchantId
            + "&currency="+ currency
            + "&components=marks,buttons";

            if(this.cartContainsGiftCard()) {
              source = source + "&disable-funding=card,paylater";
              source = source + "&enable-funding=venmo";
            } else {
              source = source + "&disable-funding=card";
              source = source + "&enable-funding=paylater,venmo";
            }

            if(this.storeFeatures.paypal.customerHasVault) {
              source = source + "&intent=capture";
              this.savePaypalVault = false;
            } else {
              if(this.storeFeatures.paypal.hasVaultEnabled) {
                this.savePaypalVault = false;
              } else {
                this.savePaypalVault = false;
              }
            }
            script.src = source;
          script.setAttribute("data-partner-attribution-id", this.storeFeatures.paypal.bnCode);
          if(this.storeFeatures.paypal.idToken!=null) {
            script.setAttribute("data-user-id-token", this.storeFeatures.paypal.idToken);
          }
          script.type = 'text/javascript';
          script.onload = () => {
            console.error('--Paypal script loaded--');
            $main.initializePaypal_regular('paypal-now-btn', 1);
          };
          script.onerror = () => {
            console.error('--Paypal script Failed to loaded--');
          };
          
          head.appendChild(script);
        }
        if ($auth.isGuestLogin()) {
          this.profile = this.guestprofile;
        }
        if (this.profile && this.profile.customer.storeCredit != null && this.profile.customer.storeCredit > 0) {
          console.log("Profile :- ", this.profile);
          if (this.profile.customer.storeCredit != null) {
            this.storeCreditAmount = this.getRoundoffValue(parseFloat(this.profile.customer.storeCredit), this.toDecimalPlaces);
          } else {
            this.storeCreditAmount = 0.00;
          }

          console.log("this.storeCreditAmount---", this.storeCreditAmount);
          this.getStoreCreditAmountToBeCharged();
        }
        // Set for paypal vault if customer have vault id
        // if(this.profile.customer && this.storeFeatures.paypal.customerHasVault) {
        //   this.savePaypalVault = true;
        // }

        this.canZeroDollarErplyTransaction();
      }).catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      })
      .finally(() => {
        this.canShowSaveCard();
        this.choosePaymentMethod();
        this.$order.printPaymentLogs(this.$stateParams.orderId, null, " Payment page to choose payment method.").then(success => {
          console.log("Successfully Printed");
        })
          .catch(err => {
            console.log("Failed to print logs");
          });
        $spinner.hide('appSpinner');
      }
      );

    $scope.$on('$destroy', disconnect);

    this.giftCardDetails = [];
    this.giftCardDetails.push(this.getEmptyCardDetails());
    this.MaxGiftCardsDetails = 3;
  }

  mapState(state) {
    return {
      profile: state.auth.profile,
      canSaveCard: state.auth.profile.saveCard,
      cardInfo: state.order.paymentInfo,
      cartDetail: state.order.cartDetail,
      guestprofile: state.auth.guestprofile,
      storeFeatures: state.order.storeFeatures
    };
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }


  submit_withpaypalchanges_backup() {
    var $ctrl = this;
    // Un comment when terms and condition button changes needed
    // if(!this.agreement){
    //   this.$toaster.pop('success', 'Please Select Terms and Conditions');
    //   return;
    // }

    if (this.paypalAutorizationWrapper.isPaypalAuthorized) {
      if (this.cardId) {
        this.cardId = null;
      }
    }

    if (!this.cardId && !this.isAllowToPayOnlyWithGiftCards && !this.isAllowToPayWithStoreCreditOnly && !this.paypalAutorizationWrapper.isPaypalAuthorized) {
      // this.$spinner.show('appSpinner');
      this.$toaster.pop('success', 'Please select Card to continue.');
      return;
    }

    this.isCallingAPI = true;
    var reqData = {};

    var giftCardsRequest = [];
    //
    angular.forEach(this.giftCardDetails, function (item, key) {
      if (item.isCardVerified && item.amount > 0) {

        $ctrl.$spinner.show('appSpinner');
        var giftCards = {

          "giftCard": item.cardNumber,
          "amount": item.amount,
          "pin": item.cvv
        };
        $ctrl.$spinner.hide('appSpinner');
        giftCardsRequest.push(giftCards);
      }
    });

    // getGiftCardPreAuthRequest
    if (this.isAllowToPayOnlyWithGiftCards) {
      this.$spinner.show('appSpinner');
      var getGiftCardPreAuthRequest = {
        "getGiftCardPreAuthCardRequestList": giftCardsRequest
      };
      var data = {
        "getGiftCardPreAuthRequest": getGiftCardPreAuthRequest
      };
      data.orderId = this.$stateParams.orderId;
      data.totalAmount = this.orderAmount;
      if (this.isStoreCreditUsed) {
        data.storeCreditAmountToBeCharged = this.amountToBeChargedFromStoreCredit;
      } else {
        data.storeCreditAmountToBeCharged = 0.00;
      }

      this.$order.paymentUsingGiftCards(data)
        .then(
          success => {
            // this.$spinner.show('appSpinner');

            if (success.data.successCode === '0' && success.data.message === 'Approved') {
              this.$spinner.hide('appSpinner');
              this.$state.go('payment.success', {
                orderId: this.$stateParams.orderId,
                isCardSaved: true
              });

            }
            else {
              this.$spinner.hide('appSpinner');
              this.$state.go('payment.failure', {
                orderId: this.$stateParams.orderId,
                logString: JSON.stringify(success),
                reasonCode: success.data.successCode
              });
            }
          },
          error => {
            this.$spinner.hide('appSpinner');
            this.$state.go('payment.failure', {
              orderId: this.$stateParams.orderId,
              logString: JSON.stringify(error),
              reasonCode: error.data.successCode
            });
          }
        )
        .catch(err => {
          this.$auth.printCustomerGenericLogs(err);
        })
        .finally(() => {
          this.$spinner.hide('appSpinner');
          this.isCallingAPI = false;
        });
    } else if (this.isAllowToPayWithStoreCreditOnly) {

      this.$spinner.show('appSpinner');
      reqData = {};
      reqData.orderId = this.$stateParams.orderId;
      reqData.totalAmount = this.orderAmount;
      if (this.isStoreCreditUsed) {
        reqData.storeCreditAmountToBeCharged = this.amountToBeChargedFromStoreCredit;
      } else {
        reqData.storeCreditAmountToBeCharged = 0.00;
      }

      this.$order.paymentUsingStoreCredit(reqData)
        .then(
          success => {
            if (success.data.successCode === '200' && success.data.message === 'Approved') {
              this.$spinner.hide('appSpinner');
              this.$state.go('payment.success', {
                orderId: this.$stateParams.orderId,
                isCardSaved: true
              });
            }
            else {
              this.$spinner.hide('appSpinner');
              this.$state.go('payment.failure', {
                orderId: this.$stateParams.orderId,
                logString: JSON.stringify(success),
                reasonCode: success.data.successCode
              });
            }
          },
          error => {
            this.$spinner.hide('appSpinner');
            this.$state.go('payment.failure', {
              orderId: this.$stateParams.orderId,
              logString: JSON.stringify(error),
              reasonCode: error.data.successCode
            });
          }
        )
        .finally(() => {
          this.$spinner.hide('appSpinner');
          this.isCallingAPI = false;
        });
    } else {

      if (this.paypalAutorizationWrapper.isPaypalAuthorized) {
        this.$spinner.show('appSpinner');
        var orderData = {
          paypalCreateOrderId: this.paypalAutorizationWrapper.paypalCreateOrderId,
          authId: this.paypalAutorizationWrapper.authId,
          orderId: $ctrl.$stateParams.orderId
        };

        if (this.isStoreCreditUsed) {
          orderData.storeCreditAmountToBeCharged = this.amountToBeChargedFromStoreCredit;
        } else {
          orderData.storeCreditAmountToBeCharged = 0.00;
        }

        this.$order.paypalCaptureOrder(orderData).then(success => {
          this.$spinner.hide('appSpinner');
          if (success != null && success.data != null && success.data.successCode == "200") {
            $ctrl.$state.go('payment.success', {
              orderId: $ctrl.$stateParams.orderId,
              isCardSaved: true
            });
          } else {
            $ctrl.$state.go('payment.failure', {
              orderId: $ctrl.$stateParams.orderId,
              logString: JSON.stringify(success.data.additionalInfo),
              reasonCode: success.data.successCode
            });
          }
        });
      } else {
        let cardNumber = this.cardInfo.filter(card => card.id === this.cardId)[0].cardNumber;
        var giftCardData = {
          "getGiftCardPreAuthCardRequestList": giftCardsRequest
        };
        var dataRequest = {
          "orderId": this.$stateParams.orderId,
          "cardNumber": cardNumber,
          "cardId": this.cardId,
          "getGiftCardPreAuthRequest": giftCardData
        };

        if (this.isStoreCreditUsed) {
          dataRequest.storeCreditAmountToBeCharged = this.amountToBeChargedFromStoreCredit;
        } else {
          dataRequest.storeCreditAmountToBeCharged = 0.00;
        }

        // Heartland
        if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.heartLand) {
          this.$spinner.show('appSpinner');
          this.$order.paymentSubmitHeartland(dataRequest)

            .then(
              success => {
                this.$spinner.hide('appSpinner');
                if (success.data.successCode === '00' && success.data.message === this.heartand_Approval) {
                  this.$state.go('payment.success', {
                    orderId: this.$stateParams.orderId,
                    isCardSaved: true
                  });
                }
                else {
                  this.$state.go('payment.failure', {
                    orderId: this.$stateParams.orderId,
                    logString: JSON.stringify(success),
                    reasonCode: success.data.successCode
                  });
                }
              },
              error => {
                this.$spinner.hide('appSpinner');
                this.$state.go('payment.failure', {
                  orderId: this.$stateParams.orderId,
                  logString: JSON.stringify(error),
                  reasonCode: error.data.successCode
                });
              }
            )
            .catch(err => {
              this.$auth.printCustomerGenericLogs(err);
            })
            .finally(() => {
              this.$spinner.hide('appSpinner');
              this.isCallingAPI = false;
            });

        }

        // Tsys
        else if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.tsys) {
          this.$spinner.show('appSpinner');
          this.$order.paymentSubmitTsys(dataRequest)

            .then(
              success => {
                this.$spinner.hide('appSpinner');
                if (success.data.successCode === '00' && success.data.message === this.heartand_Approval) {
                  this.$state.go('payment.success', {
                    orderId: this.$stateParams.orderId,
                    isCardSaved: true
                  });
                }
                else {
                  this.$state.go('payment.failure', {
                    orderId: this.$stateParams.orderId,
                    logString: JSON.stringify(success),
                    reasonCode: success.data.successCode
                  });
                }
              },
              error => {
                this.$spinner.hide('appSpinner');
                this.$state.go('payment.failure', {
                  orderId: this.$stateParams.orderId,
                  logString: JSON.stringify(error),
                  reasonCode: error.data.successCode
                });
              }
            )
            .catch(err => {
              this.$auth.printCustomerGenericLogs(err);
            })
            .finally(() => {
              this.$spinner.hide('appSpinner');
              this.isCallingAPI = false;
            });

        }

        // Moneris
        else if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.moneris) {
          this.$spinner.show('appSpinner');
          this.$order.paymentSubmitMoneris(dataRequest)
            .then(
              success => {
                this.$spinner.hide('appSpinner');
                if (success.data.successCode === '00' && success.data.message === this.heartand_Approval) {
                  this.$state.go('payment.success', {
                    orderId: this.$stateParams.orderId,
                    isCardSaved: true
                  });
                }
                else {
                  this.$state.go('payment.failure', {
                    orderId: this.$stateParams.orderId,
                    logString: JSON.stringify(success),
                    reasonCode: success.data.successCode
                  });
                }
              },
              error => {
                this.$spinner.hide('appSpinner');
                this.$state.go('payment.failure', {
                  orderId: this.$stateParams.orderId,
                  logString: JSON.stringify(error),
                  reasonCode: error.data.successCode
                });
              }
            )
            .catch(err => {
              this.$auth.printCustomerGenericLogs(err);
            })
            .finally(() => {
              this.$spinner.hide('appSpinner');
              this.isCallingAPI = false;
            });

        }

        // Worldpay
        else {
          this.$spinner.show('appSpinner');
          var worldpayData = {};
          worldpayData.getGiftCardPreAuthRequest = giftCardData;

          if (this.isStoreCreditUsed) {
            worldpayData.storeCreditAmountToBeCharged = this.amountToBeChargedFromStoreCredit;
          } else {
            worldpayData.storeCreditAmountToBeCharged = 0.00;
          }


          this.$order.paymentSubmit(this.$stateParams.orderId, this.cardId, cardNumber, worldpayData)
            .then(
              success => {
                this.$spinner.hide('appSpinner');
                if (success.data.successCode === '0' && success.data.message === 'Approved') {
                  this.$state.go('payment.success', {
                    orderId: this.$stateParams.orderId,
                    isCardSaved: true
                  });
                }
                else {
                  this.$state.go('payment.failure', {
                    orderId: this.$stateParams.orderId,
                    logString: JSON.stringify(success),
                    reasonCode: success.data.successCode
                  });
                }
              },
              error => {
                if (error.data) {
                  this.$spinner.hide('appSpinner');
                  if (error.data.errorCode && error.data.errorCode === 704) {
                    this.$state.go('cart');
                    this.$toaster.pop('success', error.data.message);
                  } else {
                    this.$state.go('payment.failure', {
                      orderId: this.$stateParams.orderId,
                      logString: JSON.stringify(error),
                      reasonCode: error.data.successCode
                    });
                  }
                }
              })
            .finally(() => {
              this.$spinner.hide('appSpinner');
              this.isCallingAPI = false;
            });

        }
      }
    }
  }


  submit() {
    var $ctrl = this;
    // Un comment when terms and condition button changes needed
    if (!this.agreement) {
      this.$toaster.pop('success', 'Please Select Terms and Conditions');
      return;
    }

    if (!this.cardId && !this.isAllowToPayOnlyWithGiftCards && !this.isAllowToPayWithStoreCreditOnly &&
      !this.payWithPayPalVaultButton){
      // this.$spinner.show('appSpinner');
      this.$toaster.pop('success', 'Please select Card to continue.');
      return;
    }

    this.isCallingAPI = true;
    var reqData = {};

    var giftCardsRequest = [];
    //
    angular.forEach(this.giftCardDetails, function (item, key) {
      if (item.isCardVerified && item.amount > 0) {

        $ctrl.$spinner.show('appSpinner');
        var giftCards = {

          "giftCard": item.cardNumber,
          "amount": item.amount,
          "pin": item.cvv
        };
        $ctrl.$spinner.hide('appSpinner');
        giftCardsRequest.push(giftCards);
      }
    });

    // getGiftCardPreAuthRequest
    if (this.isAllowToPayOnlyWithGiftCards) {
      this.$spinner.show('appSpinner');
      var getGiftCardPreAuthRequest = {
        "getGiftCardPreAuthCardRequestList": giftCardsRequest
      };
      var data = {
        "getGiftCardPreAuthRequest": getGiftCardPreAuthRequest
      };
      data.orderId = this.$stateParams.orderId;
      data.totalAmount = this.orderAmount;
      if (this.isStoreCreditUsed) {
        data.storeCreditAmountToBeCharged = this.amountToBeChargedFromStoreCredit;
      } else {
        data.storeCreditAmountToBeCharged = 0.00;
      }

      this.$order.paymentUsingGiftCards(data)
        .then(
          success => {
            // this.$spinner.show('appSpinner');

            if (success.data.successCode === '0' && success.data.message === 'Approved') {
              this.$spinner.hide('appSpinner');
              this.$state.go('payment.success', {
                orderId: this.$stateParams.orderId,
                isCardSaved: true
              });

            }
            else {
              this.$spinner.hide('appSpinner');
              this.$state.go('payment.failure', {
                orderId: this.$stateParams.orderId,
                logString: JSON.stringify(success),
                reasonCode: success.data.successCode
              });
            }
          },
          error => {
            this.$spinner.hide('appSpinner');
            this.$state.go('payment.failure', {
              orderId: this.$stateParams.orderId,
              logString: JSON.stringify(error),
              reasonCode: error.data.successCode
            });
          }
        )
        .catch(err => {
          this.$auth.printCustomerGenericLogs(err);
        })
        .finally(() => {
          this.$spinner.hide('appSpinner');
          this.isCallingAPI = false;
        });
    } else if (this.isAllowToPayWithStoreCreditOnly) {

      this.$spinner.show('appSpinner');
      reqData = {};
      reqData.orderId = this.$stateParams.orderId;
      reqData.totalAmount = this.orderAmount;
      if (this.isStoreCreditUsed) {
        reqData.storeCreditAmountToBeCharged = this.amountToBeChargedFromStoreCredit;
      } else {
        reqData.storeCreditAmountToBeCharged = 0.00;
      }

      this.$order.paymentUsingStoreCredit(reqData)
        .then(
          success => {
            if (success.data.successCode === '200' && success.data.message === 'Approved') {
              this.$spinner.hide('appSpinner');
              this.$state.go('payment.success', {
                orderId: this.$stateParams.orderId,
                isCardSaved: true
              });
            }
            else {
              this.$spinner.hide('appSpinner');
              this.$state.go('payment.failure', {
                orderId: this.$stateParams.orderId,
                logString: JSON.stringify(success),
                reasonCode: success.data.successCode
              });
            }
          },
          error => {
            this.$spinner.hide('appSpinner');
            this.$state.go('payment.failure', {
              orderId: this.$stateParams.orderId,
              logString: JSON.stringify(error),
              reasonCode: error.data.successCode
            });
          }
        )
        .finally(() => {
          this.$spinner.hide('appSpinner');
          this.isCallingAPI = false;
        });
    } else if(this.payWithPayPalVaultButton) {
      // paypal vault
      this.$spinner.show('appSpinner');
      var getGiftCardPreAuthRequest1 = {
        "getGiftCardPreAuthCardRequestList": giftCardsRequest
      };
      var dataForPaypalVaultRequest = {
        "getGiftCardPreAuthRequest": getGiftCardPreAuthRequest1
      };
      dataForPaypalVaultRequest.orderId = this.$stateParams.orderId;
      dataForPaypalVaultRequest.totalAmount = this.orderAmount;
      if (this.isStoreCreditUsed) {
        dataForPaypalVaultRequest.storeCreditAmountToBeCharged = this.amountToBeChargedFromStoreCredit;
      } else {
        dataForPaypalVaultRequest.storeCreditAmountToBeCharged = 0.00;
      }
      dataForPaypalVaultRequest.saveVault = this.savePaypalVault;
      dataForPaypalVaultRequest.proceedingWithVault = true;

      this.$order.paypalCreateVaultOrder(dataForPaypalVaultRequest).then(
        success => {
          if (success.data.successCode === '200' && success.data.message === 'Approved') {
            this.$spinner.hide('appSpinner');
            this.$state.go('payment.success', {
              orderId: this.$stateParams.orderId,
              isCardSaved: true
            });
          }
          else {
            this.$spinner.hide('appSpinner');
            this.$state.go('payment.failure', {
              orderId: this.$stateParams.orderId,
              logString: JSON.stringify(success),
              reasonCode: success.data.successCode
            });
          }
        },
        error => {
          this.$spinner.hide('appSpinner');
          this.$state.go('payment.failure', {
            orderId: this.$stateParams.orderId,
            logString: JSON.stringify(error),
            reasonCode: error.data.successCode
          });
        }
      )
      .finally(() => {
        this.$spinner.hide('appSpinner');
        this.isCallingAPI = false;
      });

    } else {
      let cardNumber = this.cardInfo.filter(card => card.id === this.cardId)[0].cardNumber;
      var giftCardData = {
        "getGiftCardPreAuthCardRequestList": giftCardsRequest
      };
      var dataRequest = {
        "orderId": this.$stateParams.orderId,
        "cardNumber": cardNumber,
        "cardId": this.cardId,
        "getGiftCardPreAuthRequest": giftCardData
      };

      if (this.isStoreCreditUsed) {
        dataRequest.storeCreditAmountToBeCharged = this.amountToBeChargedFromStoreCredit;
      } else {
        dataRequest.storeCreditAmountToBeCharged = 0.00;
      }

      // Heartland
      if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.heartLand) {
        this.$spinner.show('appSpinner');
        this.$order.paymentSubmitHeartland(dataRequest)

          .then(
            success => {
              this.$spinner.hide('appSpinner');
              if (success.data.successCode === '00' && success.data.message === this.heartand_Approval) {
                this.$state.go('payment.success', {
                  orderId: this.$stateParams.orderId,
                  isCardSaved: true
                });
              }
              else {
                this.$state.go('payment.failure', {
                  orderId: this.$stateParams.orderId,
                  logString: JSON.stringify(success),
                  reasonCode: success.data.successCode
                });
              }
            },
            error => {
              this.$spinner.hide('appSpinner');
              this.$state.go('payment.failure', {
                orderId: this.$stateParams.orderId,
                logString: JSON.stringify(error),
                reasonCode: error.data.successCode
              });
            }
          )
          .catch(err => {
            this.$auth.printCustomerGenericLogs(err);
          })
          .finally(() => {
            this.$spinner.hide('appSpinner');
            this.isCallingAPI = false;
          });

      }

      // Tsys
      else if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.tsys) {
        this.$spinner.show('appSpinner');
        this.$order.paymentSubmitTsys(dataRequest)

          .then(
            success => {
              this.$spinner.hide('appSpinner');
              if (success.data.successCode === '00' && success.data.message === this.heartand_Approval) {
                this.$state.go('payment.success', {
                  orderId: this.$stateParams.orderId,
                  isCardSaved: true
                });
              }
              else {
                this.$state.go('payment.failure', {
                  orderId: this.$stateParams.orderId,
                  logString: JSON.stringify(success),
                  reasonCode: success.data.successCode
                });
              }
            },
            error => {
              this.$spinner.hide('appSpinner');
              this.$state.go('payment.failure', {
                orderId: this.$stateParams.orderId,
                logString: JSON.stringify(error),
                reasonCode: error.data.successCode
              });
            }
          )
          .catch(err => {
            this.$auth.printCustomerGenericLogs(err);
          })
          .finally(() => {
            this.$spinner.hide('appSpinner');
            this.isCallingAPI = false;
          });

      }

      // Moneris
      else if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.moneris) {
        this.$spinner.show('appSpinner');
        this.$order.paymentSubmitMoneris(dataRequest)
          .then(
            success => {
              this.$spinner.hide('appSpinner');
              if (success.data.successCode === '00' && success.data.message === this.heartand_Approval) {
                this.$state.go('payment.success', {
                  orderId: this.$stateParams.orderId,
                  isCardSaved: true
                });
              }
              else {
                this.$state.go('payment.failure', {
                  orderId: this.$stateParams.orderId,
                  logString: JSON.stringify(success),
                  reasonCode: success.data.successCode
                });
              }
            },
            error => {
              this.$spinner.hide('appSpinner');
              this.$state.go('payment.failure', {
                orderId: this.$stateParams.orderId,
                logString: JSON.stringify(error),
                reasonCode: error.data.successCode
              });
            }
          )
          .catch(err => {
            this.$auth.printCustomerGenericLogs(err);
          })
          .finally(() => {
            this.$spinner.hide('appSpinner');
            this.isCallingAPI = false;
          });

      }

      // Worldpay
      else {
        this.$spinner.show('appSpinner');
        var worldpayData = {};
        worldpayData.getGiftCardPreAuthRequest = giftCardData;

        if (this.isStoreCreditUsed) {
          worldpayData.storeCreditAmountToBeCharged = this.amountToBeChargedFromStoreCredit;
        } else {
          worldpayData.storeCreditAmountToBeCharged = 0.00;
        }


        this.$order.paymentSubmit(this.$stateParams.orderId, this.cardId, cardNumber, worldpayData)
          .then(
            success => {
              this.$spinner.hide('appSpinner');
              if (success.data.successCode === '0' && success.data.message === 'Approved') {
                this.$state.go('payment.success', {
                  orderId: this.$stateParams.orderId,
                  isCardSaved: true
                });
              }
              else {
                this.$state.go('payment.failure', {
                  orderId: this.$stateParams.orderId,
                  logString: JSON.stringify(success),
                  reasonCode: success.data.successCode
                });
              }
            },
            error => {
              if (error.data) {
                this.$spinner.hide('appSpinner');
                if (error.data.errorCode && error.data.errorCode === 704) {
                  this.$state.go('cart');
                  this.$toaster.pop('success', error.data.message);
                } else {
                  this.$state.go('payment.failure', {
                    orderId: this.$stateParams.orderId,
                    logString: JSON.stringify(error),
                    reasonCode: error.data.successCode
                  });
                }
              }
            })
          .finally(() => {
            this.$spinner.hide('appSpinner');
            this.isCallingAPI = false;
          });

      }
    }
  }


  paymentByNewCard() {
    let device = this.getDeviceParameter();
    this.isCallingAPI = true;
    // Un comment when terms and condition button changes needed
    // if(!this.agreement)
    // {
    //   this.$toaster.pop('success', 'Please Select Terms and Conditions');
    //   this.isCallingAPI = false;
    //   return;
    // }

    if (this.paypalAutorizationWrapper.isPaypalAuthorized) {
      // this.$spinner.show('appSpinner');
      // New card payment doesn't allowed when paypal is used.
      this.$toaster.pop('success', 'Paypal Authorized succefully.');
      this.submit();
      return;
    }

    var giftCardsRequest = [];
    angular.forEach(this.giftCardDetails, function (item, key) {
      if (item.isCardVerified && item.amount > 0) {
        var giftCards = {
          "giftCard": item.cardNumber,
          "amount": item.amount,
          "pin": item.cvv
        };
        giftCardsRequest.push(giftCards);
      }
    });
    var giftCardData = {
      "getGiftCardPreAuthCardRequestList": giftCardsRequest
    };

    var dataRequest = {
      "getGiftCardPreAuthRequest": giftCardData
    };

    if (this.isStoreCreditUsed) {
      dataRequest.storeCreditAmountToBeCharged = this.amountToBeChargedFromStoreCredit;
    } else {
      dataRequest.storeCreditAmountToBeCharged = 0.00;
    }

    // New card payment by heartland
    if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.heartLand) {
      this.$spinner.show('appSpinner');

      // Function to save giftcardRequest in orderservice
      // this.$order.setGiftCardRequest(giftCardsRequest);

      this.showHeartLandPage = true;
      this.giftCardsRequest = giftCardsRequest;
      // this.callHeartLandPage(giftCardsRequest);
      this.callHeartLandCustom(giftCardsRequest, this.getStoreCredit());
      this.$spinner.hide('appSpinner');
    }
    // New card payment by Tsys
    else if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.tsys) {
      this.$spinner.show('appSpinner');
      this.showHeartLandPage = false;
      this.giftCardsRequest = giftCardsRequest;
      this.callTsysCustom(giftCardsRequest, this.getStoreCredit());
      this.$spinner.hide('appSpinner');
    }
    // New card payment by Moneris
    else if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.moneris) {
      this.$spinner.show('appSpinner');
      this.showHeartLandPage = false;
      this.giftCardsRequest = giftCardsRequest;
      this.callMonerisCustom(giftCardsRequest, this.getStoreCredit());
      this.$spinner.hide('appSpinner');
    }
    // New card payment by Worldpay
    else {
      this.$spinner.show('appSpinner');
      this.$order.initializePayment(this.$stateParams.orderId, device, dataRequest)
        .then(
          success => {
            this.$spinner.hide('appSpinner');
            if (!success.data.additionalInfo || success.data.additionalInfo === 'Nil') {
              this.$toaster.pop('success', 'Unable to process your payment currently. Please try again later.');
              return;
            }
            this.goToMerchantPage(success.data);
          },
          err => {
            // console.log(err);
            if (err.data) {
              if (err.data.errorCode && err.data.errorCode === 704) {
                this.$state.go('cart');
              }
            }
            this.$spinner.hide('appSpinner');
            this.$toaster.pop('success', err.data.message);
            this.isCallingAPI = false;
          }
        )
        .catch(err => {
          this.$auth.printCustomerGenericLogs(err);
        });
    }
  }

  goToMerchantPage(data, method) {
    method = method || 'post';

    let form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', data.message);

    let payIdField = document.createElement('input');
    payIdField.setAttribute('type', 'hidden');
    payIdField.setAttribute('name', 'PaymentID');
    payIdField.setAttribute('value', data.additionalInfo);
    form.appendChild(payIdField);

    let returnMethodField = document.createElement('input');
    returnMethodField.setAttribute('type', 'hidden');
    returnMethodField.setAttribute('name', 'ReturnMethod');
    returnMethodField.setAttribute('value', 'POST');
    form.appendChild(returnMethodField);

    document.body.appendChild(form);
    form.submit();
  }

  getDeviceParameter() {
    if (window.innerWidth <= 576) {
      return 'm';
    }
    else if (window.innerWidth > 576 && window.innerWidth <= 768) {
      return 't';
    }
    else if (window.innerWidth > 768) {
      return 'd';
    }
  }

  addCard(index) {

    var amountminusgift = this.orderAmount - this.amountToBeChargedFromStoreCredit - this.getTotalGiftCardAddedAmount();
    amountminusgift = this.getRoundoffValue(amountminusgift, this.toDecimalPlaces);
    if (amountminusgift == 0) {
      this.isAllowedToAdd = false;
      this.$toaster.pop('success', "Total amount is already covered.");
      return;
    }

    this.isAllowedToAddCard();
    this.canZeroDollarErplyTransaction();
    if (this.isAllowedToAdd) {
      if (this.orderAmount <= this.getTotalGiftCardAddedAmount()) {
        this.$toaster.pop('success', 'Gift Card amount has reached the limit');
      } else {
        var isCardVerified = this.giftCardDetails[index].isCardVerified;
        if (isCardVerified) {
          if (this.giftCardDetails.length < this.MaxGiftCardsDetails) {
            this.giftCardDetails.push(this.getEmptyCardDetails());
          }
        } else {
          this.$toaster.pop('success', 'Please apply the card');
        }
      }
    } else {
      this.$toaster.pop('success', 'Please apply the card');
    }
  }

  removeCard(index) {

    var total = 0;
    this.isAllowedToAdd = true;
    if (this.giftCardDetails.length >= 1) {
      // this.giftCardDetails.push(this.getEmptyCardDetails());
      if (this.giftCardDetails[index].isCardVerified) {
        var removeIndex = this.giftCardNumbers.indexOf(this.giftCardDetails[index].cardNumber);
        this.giftCardNumbers.splice(removeIndex, 1);
      }
      this.giftCardDetails.splice(index, 1);
      // Pushing empty if all giftcards removed
      if (this.giftCardDetails.length < 1) {
        this.giftCardDetails.push(this.getEmptyCardDetails());
      }
    }
    var previousTotalAmount = 0.00;
    for (var i = 0; i < this.giftCardDetails.length; i++) {
      console.log(this.giftCardDetails[i].actualAmount);
      if (this.giftCardDetails[i].actualAmount > 0) {
        total = total + this.giftCardDetails[i].actualAmount;

        if (this.isStoreCreditUsed) {
          this.amountMinusStoreCredit = this.orderAmount - this.amountToBeChargedFromStoreCredit;
          if (this.amountMinusStoreCredit >= total) {
            this.isAllowedToAdd = true;
            this.giftCardDetails[i].amount = this.getRoundoffValue(this.giftCardDetails[i].actualAmount, this.toDecimalPlaces);
            previousTotalAmount = previousTotalAmount + this.giftCardDetails[i].amount;
          } else {
            if (this.amountMinusStoreCredit - previousTotalAmount > this.giftCardDetails[i].actualAmount) {
              this.isAllowedToAdd = true;
              this.giftCardDetails[i].amount = this.getRoundoffValue(this.giftCardDetails[i].actualAmount, this.toDecimalPlaces);
            }
            else {
              this.isAllowedToAdd = false;
              this.giftCardDetails[i].amount = this.getRoundoffValue(this.amountMinusStoreCredit - previousTotalAmount, this.toDecimalPlaces);
            }
          }
        } else {
          if (this.orderAmount >= total) {
            this.isAllowedToAdd = true;
            this.giftCardDetails[i].amount = this.getRoundoffValue(this.giftCardDetails[i].actualAmount, this.toDecimalPlaces);
            previousTotalAmount = previousTotalAmount + this.giftCardDetails[i].amount;
          } else {
            if (this.orderAmount - previousTotalAmount > this.giftCardDetails[i].actualAmount) {
              this.isAllowedToAdd = true;
              this.giftCardDetails[i].amount = this.getRoundoffValue(this.giftCardDetails[i].actualAmount, this.toDecimalPlaces);
            }
            else {
              this.isAllowedToAdd = false;
              this.giftCardDetails[i].amount = this.getRoundoffValue(this.orderAmount - previousTotalAmount, this.toDecimalPlaces);
            }
          }
        }


      }
    }
    if (this.orderAmount > 0) {
      this.setIsAllowToPayOnlyWithGiftCards();
    }
    this.getStoreCreditAmountToBeCharged();
    this.canZeroDollarErplyTransaction();
  }

  getRoundoffValue(number, places) {
    // console.log(" number.toFixed(places) : "+  number.toFixed(places));
    return parseFloat(number.toFixed(places));
  }

  getEmptyCardDetails() {
    return {
      "cardNumber": '',
      "cvv": '',
      "isCardVerified": false,
      "amount": 0.00,
      "isAllowedToAdd": true,
      "actualAmount": 0.00
    };
  }

  verifyCard(index) {
    this.waitUntilVerify = true;
    var giftCardExits = this.giftCardNumbers.filter(gift => gift === this.giftCardDetails[index].cardNumber);
    // console.log("giftCardExits",giftCardExits);
    var data = {
      "giftCard": this.giftCardDetails[index].cardNumber
    };
    if (giftCardExits.length != 0) {
      this.waitUntilVerify = false;
      this.$toaster.pop('success', 'The gift card has added already');
    } else {
      this.validateGiftCardDetails(data, index);
    }
    //  this.validateGiftCardDetails(data,index);
  }

  validateGiftCardDetails(data, index) {
    this.$order.validateGiftCardDetails(data)
      .then(
        success => {
          // console.log("success", success);
          if (success.data.amount > 0) {
            this.giftCardDetails[index].actualAmount = success.data.amount;
            this.giftCardDetails[index].amount = this.getRoundoffValue(this.validateBalanceAmount(index, success.data.amount), this.toDecimalPlaces);
            this.giftCardDetails[index].isCardVerified = true;
            this.giftCardNumbers.push(this.giftCardDetails[index].cardNumber);
          } else {
            this.$toaster.pop('success', "Entered Gift card has zero balance and hence can't be applied");
          }
          this.isAllowedToAddCard();
          if (this.orderAmount > 0) {
            this.setIsAllowToPayOnlyWithGiftCards();
          }
          this.waitUntilVerify = false;
        },
        error => {
          this.waitUntilVerify = false;
          this.$toaster.pop('success', error.data.message);
          // console.log("error", error);
          this.giftCardDetails[index].amount = 0.00;
          this.giftCardDetails[index].isCardVerified = false;
        }
      )
      .catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      })
      .finally(() => {
        this.choosePaymentMethod();
        this.getStoreCreditAmountToBeCharged();
        this.$spinner.hide('appSpinner');
      });
  }

  isAllowedToAddCard() {

    // Allow to show add or remove if only one giftcard
    if (this.giftCardDetails.length == 1) {
      this.isAllowedToAdd = true;
      this.isAllowedToRemove = true;
    } else {

      if (this.isStoreCreditUsed) {
        var amountminusStoreCredit = this.orderAmount - this.getStoreCredit();
        if (amountminusStoreCredit == 0) {
          this.isAllowedToAdd = false;
          this.$toaster.pop('success', 'Total amount has already covered up');
          return;
        }
      }
      var count = 0;
      // Validate to add card across all the giftcards
      angular.forEach(this.giftCardDetails, function (item, key) {
        if (item) {
          count = count + (item.isCardVerified ? 1 : 0);
        }
      });
      // console.log("count",count);
      // console.log(this.giftCardDetails.length);
      if (count == this.giftCardDetails.length) {
        this.isAllowedToAdd = true;
      } else {
        this.isAllowedToAdd = false;
      }
    }
  }

  validateBalanceAmount(index, amount) {
    var total = 0.00;
    var giftCardAmountAddedSofar = 0.00;
    angular.forEach(this.giftCardDetails, function (item, key) {
      if (item) {
        total = total + item.amount;
      }
    });
    giftCardAmountAddedSofar = total;
    total = total + amount;

    if (this.isStoreCreditUsed) {
      this.amountMinusStoreCredit = this.orderAmount - this.amountToBeChargedFromStoreCredit;
      this.amountMinusStoreCredit = this.getRoundoffValue(this.amountMinusStoreCredit, this.toDecimalPlaces);
      if (this.amountMinusStoreCredit < amount) {
        if (this.amountMinusStoreCredit - giftCardAmountAddedSofar < amount) {
          this.isAllowedToAdd = false;
          return this.amountMinusStoreCredit - giftCardAmountAddedSofar;
        } else {
          this.isAllowedToAdd = false;
          return this.amountMinusStoreCredit;
        }
      } else if (this.amountMinusStoreCredit >= total) {
        this.isAllowedToAdd = true;
        return amount;
      } else {
        this.isAllowedToAdd = false;
        if (total - this.amountMinusStoreCredit > amount) {
          return amount;
        } else {
          return amount - (total - this.amountMinusStoreCredit);
        }
      }


    } else {
      if (this.orderAmount < amount) {
        if (this.orderAmount - giftCardAmountAddedSofar < amount) {
          this.isAllowedToAdd = false;
          return this.orderAmount - giftCardAmountAddedSofar;
        } else {
          this.isAllowedToAdd = false;
          return this.orderAmount;
        }
      }
      else if (this.orderAmount >= total) {
        this.isAllowedToAdd = true;
        return amount;
      }
      else {
        if (total - this.orderAmount > amount) {
          this.isAllowedToAdd = false;
          return amount;
        } else {
          this.isAllowedToAdd = false;
          return amount - (total - this.orderAmount);
        }
      }
    }
  }

  isMobileOnly() {
    return this.$auth.isMobileDevice();
  }

  getTotalGiftCardAddedAmount() {
    var total = 0.00;
    angular.forEach(this.giftCardDetails, function (item, key) {
      if (item) {
        total = total + item.amount;
      }
    });
    return this.getRoundoffValue(total, this.toDecimalPlaces);
    // return total;
  }

  // isIpad() {
  //   return this.$order.isIpad();
  // }

  isIpad() {
    return (this.$window.innerWidth < 1248 && this.$window.innerWidth > 767);
  }

  isIpadPotrait() {
    if (this.isIpad()) {
      return (this.$window.innerWidth < 785);
    } else {
      return false;
    }
  }

  isIpadLandscape() {
    if (this.isIpad()) {
      return (this.$window.innerWidth > 1037);
    } else {
      return false;
    }
  }

  cartContainsOnlyGift() {
    const totalItemsInCart = this.cartDetail.cartItems.length;
    var isCardhasGiftOnly = this.cartContainsGiftCard();
    return isCardhasGiftOnly && (totalItemsInCart === this.cartContainsGiftCard());
  }

  cartContainsGiftCard() {
    return this.cartDetail.cartItems
      ? this.cartDetail.cartItems.filter(item => {
        var masterCode = item.item.masterProduct.masterCode;
        var seriesNumber = masterCode.charAt(0);
        var categoryId = item.item.masterProduct.category.id;
        return seriesNumber === '9' && categoryId === this.isMiscelleneousCategory;
      }).length
      : false;
  }


  callHeartLandCustom(giftCardsRequest, storeCreditAmountCharged) {
    this.giftCardsRequest = giftCardsRequest;
    this.showHeartLandPage = true;
    var useStoreCreditflag = false;
    if (this.isStoreCreditAmountTobeUsed()) {
      useStoreCreditflag = true;
    }

    this.$state.go('payment-detail', { giftcardReq: this.giftCardsRequest, storeCreditAmountToBeCharged: this.amountToBeChargedFromStoreCredit });
  }

  callTsysCustom(giftCardsRequest, storeCreditAmountCharged) {
    this.giftCardsRequest = giftCardsRequest;
    this.showHeartLandPage = true;
    var useStoreCreditflag = false;
    if (this.isStoreCreditAmountTobeUsed()) {
      useStoreCreditflag = true;
    }

    this.$state.go('tsys-payment', { giftcardReq: this.giftCardsRequest, storeCreditAmountToBeCharged: this.amountToBeChargedFromStoreCredit });
  }

  callMonerisCustom(giftCardsRequest, storeCreditAmountCharged) {
    this.giftCardsRequest = giftCardsRequest;
    this.showHeartLandPage = true;
    var useStoreCreditflag = false;
    if (this.isStoreCreditAmountTobeUsed()) {
      useStoreCreditflag = true;
    }

    this.$state.go('moneris-payment', { giftcardReq: this.giftCardsRequest, storeCreditAmountToBeCharged: this.amountToBeChargedFromStoreCredit });
  }

  canZeroDollarErplyTransaction() {
    console.log("this.giftCardDetails[0].isCardVerified : ", this.giftCardDetails[0].isCardVerified);
    /*
    if (this.orderAmount == 0.00 && this.isErplyStore && !this.isAllowToPayOnlyWithGiftCards) {
      if((this.giftCardDetails.length == 1 && !this.giftCardDetails[0].isCardVerified)){
        this.allowErplyZeroDollarTrasaction = true;
      } else {
        this.allowErplyZeroDollarTrasaction = false;
      }
    } else {
      this.allowErplyZeroDollarTrasaction = false;
    }
    */
  }

  doErplyZeroDollarTransaction() {
    this.$spinner.show('appSpinner');
    this.$order.doErplyZeroDollarTransaction(this.$stateParams.orderId)
      .then(
        success => {
          // this.$spinner.show('appSpinner');

          if (success.data.successCode === '0' && success.data.message === 'Approved') {
            this.$spinner.hide('appSpinner');
            this.$state.go('payment.success', {
              orderId: this.$stateParams.orderId,
              isCardSaved: true
            });

          }
          else {
            this.$spinner.hide('appSpinner');
            this.$state.go('payment.failure', {
              orderId: this.$stateParams.orderId,
              logString: JSON.stringify(success),
              reasonCode: success.data.successCode
            });
          }
        },
        error => {
          this.$spinner.hide('appSpinner');
          this.$state.go('payment.failure', {
            orderId: this.$stateParams.orderId,
            logString: JSON.stringify(error),
            reasonCode: error.data.successCode
          });
        }
      )
      .catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      })
      .finally(() => {
        this.$spinner.hide('appSpinner');
        this.isCallingAPI = false;
      });
  }

  toggleSaveUserCard(saveCard) {
    console.log("SaveCard : " + saveCard);
    this.$order.canSaveUserCard(saveCard);
  }

  isGuestProfile() {
    if(!this.profile || !this.profile.customer || this.profile.customer.isGuest) {
      return true;
    } else {
      return false;
    }
  }

  canShowSaveCard() {
    if (this.profile && this.profile.customer) {
      if (this.profile.customer.isGuest) {
        this.showSavedCard = false;
      } else {
        this.showSavedCard = true;
        if(this.cardInfo!=null && this.cardInfo.length>0) {
          this.paymentMethods.push({
            "value": "savedCard",
            "name": "Pay with saved card",
            "logo": false,
            "cardLogo": true,
            "id": "savedcard-pay-now",
            "lastChoosen": false,
            "type": "unique",
            "disable": false,
            "order": 2
          });
        }
      }
    } else {
      this.showSavedCard = false;
    }
  }

  initializePaypal() {
    var $ctrl = this;
    console.log("paypal integration ----> ", window.paypal);

    if (window.paypal && window.paypal.Buttons) {
      var button = window.paypal
        .Buttons({
          style: {
            shape: "rect",
            layout: "vertical",
            color: "white",
            label: "paypal",
            tagline: false
          },

          async createOrder() {


            var giftCardsRequest = [];
            angular.forEach($ctrl.giftCardDetails, function (item, key) {
              if (item.isCardVerified && item.amount > 0) {

                $ctrl.$spinner.show('appSpinner');
                var giftCards = {

                  "giftCard": item.cardNumber,
                  "amount": item.amount,
                  "pin": item.cvv
                };
                $ctrl.$spinner.hide('appSpinner');
                giftCardsRequest.push(giftCards);
              }
            });
            var giftCardData = {
              "getGiftCardPreAuthCardRequestList": giftCardsRequest
            };

            var dataRequest = {
              "orderId": $ctrl.$stateParams.orderId,
              "getGiftCardPreAuthRequest": giftCardData
            };

            const success = await $ctrl.$order.paypalCreateOrder(dataRequest);
            // console.log("Success info :", success.data.id);
            return success.data.id;
          },

          async onApprove(data, actions) {
            // console.log("Inside OnApprove data ---", data);
            // console.log("Inside OnApprove actions ---", actions);
            var orderData = {
              paypalCreateOrderId: data.orderID,
              orderId: $ctrl.$stateParams.orderId
            };

            const success = await $ctrl.$order.paypalCaptureOrder(orderData).then(success => {
              if (success != null && success.data != null && success.data.successCode == "200") {
                $ctrl.$state.go('payment.success', {
                  orderId: $ctrl.$stateParams.orderId,
                  isCardSaved: true
                });
              } else {
                $ctrl.$state.go('payment.failure', {
                  orderId: $ctrl.$stateParams.orderId,
                  logString: JSON.stringify(success.data.additionalInfo),
                  reasonCode: success.data.successCode
                });
              }
            });
          },

          onError: function (err) {
            $ctrl.$state.go('payment.failure', {
              orderId: $ctrl.$stateParams.orderId,
              logString: JSON.stringify(err)
              // reasonCode: error.data.successCode
            });
          }

        });
      if (!button.isEligible()) {
        // Skip rendering if not eligible
        return;
      }
      button.render("#paypal-button-container");
    }
  }


  initializePaypal1(fundingSource, id) {
    var $ctrl = this;
    // console.log("paypal integration ----> ", window.paypal);

    var giftCardsRequest = [];
    angular.forEach($ctrl.giftCardDetails, function (item, key) {
      if (item.isCardVerified && item.amount > 0) {

        $ctrl.$spinner.show('appSpinner');
        var giftCards = {

          "giftCard": item.cardNumber,
          "amount": item.amount,
          "pin": item.cvv
        };
        $ctrl.$spinner.hide('appSpinner');
        giftCardsRequest.push(giftCards);
      }
    });
    var giftCardData = {
      "getGiftCardPreAuthCardRequestList": giftCardsRequest
    };

    var dataRequest = {
      "orderId": this.$stateParams.orderId,
      "getGiftCardPreAuthRequest": giftCardData
    };

    this.paypalAutorizationWrapper.authorizedAmount = this.getRoundoffValue(this.orderAmount - this.getTotalGiftCardAddedAmount() - this.amountToBeChargedFromStoreCredit, this.toDecimalPlaces);

    // Render PayPal Now (standard paypal funding) if eligible
    if (window.paypal.FUNDING && window.paypal.Buttons) {
      var marks = window.paypal.Marks({
        fundingSource: fundingSource
      });
      // Only render if eligible
      if (marks.isEligible()) {
        setTimeout(() => {
          marks.render('#' + id + '-marks');
        }, 1000);
      }

      var btn = window.paypal.Buttons(
        {
          fundingSource: fundingSource,
          createOrder: function (data, actions) {
            return actions.order.create({
              intent: "AUTHORIZE",   // 
              purchase_units: [{
                amount: {
                  value: $ctrl.paypalAutorizationWrapper.authorizedAmount,
                  currency_code: "USD"
                }
              }]
            });
          },
          onApprove: function (data, actions) {
            return actions.order.authorize().then(function (authorization) {
              // console.log("Inside OnApprove data ---", data);
              // console.log("Inside OnApprove actions ---", actions);
              if (data && data.orderID) {
                $ctrl.paypalAutorizationWrapper.paypalCreateOrderId = data.orderID;
                // console.log("Authorized:", $ctrl.paypalAutorizationWrapper.paypalCreateOrderId, authorization);
                if (authorization.purchase_units[0] && authorization.purchase_units[0].payments.authorizations[0].id) {
                  $ctrl.paypalAutorizationWrapper.showPaypal = false;
                  $ctrl.paypalAutorizationWrapper.isPaypalAuthorized = true;
                  $ctrl.paypalAutorizationWrapper.authId = authorization.purchase_units[0].payments.authorizations[0].id;
                  var paypalAuthorizedOrderWrapper = {
                    'orderId': $ctrl.$stateParams.orderId,
                    'authId': $ctrl.paypalAutorizationWrapper.authId,
                    'paypalCreateOrderId': $ctrl.paypalAutorizationWrapper.paypalCreateOrderId
                  };
                  $ctrl.$order.savePaypalAuthorizedOrder(paypalAuthorizedOrderWrapper).then(success => {
                    // console.log("Authorized order saved successfully", success);
                  });
                  $ctrl.scrollToPaynow();
                }
              } else {
                // $ctrl.paypalAutorizationWrapper.showPaypal = true;
                $ctrl.paypalAutorizationWrapper.isPaypalAuthorized = false;
                $ctrl.$toaster.pop('success', 'Authorized Failed');
              }
            });
          }
        });
      // Only render if eligible
      if (btn.isEligible()) {
        setTimeout(() => {
          btn.render('#' + id + '-container');
        }, 1000);
      } else {
        // If not eligible, optionally hide or show a fallback message
        document.getElementById(id + '-container').innerHTML = '<p>Not eligible</p>';
      }
    }
  }




  initializePaypal3(fundingSource, id) {
    var $ctrl = this;
    // console.log("paypal integration ----> ", window.paypal);

    if (window.paypal && window.paypal.Buttons) {

      if (window.paypal.FUNDING && window.paypal.Buttons) {
        var marks = window.paypal.Marks({
          fundingSource: fundingSource
        });
        // Only render if eligible
        if (marks.isEligible()) {
          setTimeout(() => {
            marks.render('#' + id + '-marks');
          }, 1000);
        }

        var btn = window.paypal
          .Buttons({
            style: {
              shape: "rect",
              layout: "vertical",
              color: "white",
              label: "paypal",
              tagline: false
            },
            fundingSource: fundingSource,
            async createOrder() {
              var giftCardsRequest = [];
              angular.forEach($ctrl.giftCardDetails, function (item, key) {
                if (item.isCardVerified && item.amount > 0) {

                  $ctrl.$spinner.show('appSpinner');
                  var giftCards = {

                    "giftCard": item.cardNumber,
                    "amount": item.amount,
                    "pin": item.cvv
                  };
                  $ctrl.$spinner.hide('appSpinner');
                  giftCardsRequest.push(giftCards);
                }
              });
              var giftCardData = {
                "getGiftCardPreAuthCardRequestList": giftCardsRequest
              };

              var dataRequest = {
                "orderId": $ctrl.$stateParams.orderId,
                "getGiftCardPreAuthRequest": giftCardData
              };

              const success = await $ctrl.$order.paypalCreateOrder(dataRequest);
              // console.log("Success info :", success.data.id);
              return success.data.id;
            },

            async onApprove(data, actions) {
              // console.log("Inside OnApprove data ---", data);
              // console.log("Inside OnApprove actions ---", actions);
              var orderData = {
                paypalCreateOrderId: data.orderID,
                orderId: $ctrl.$stateParams.orderId
              };

              const success = await $ctrl.$order.paypalCaptureOrder(orderData).then(success => {
                if (success != null && success.data != null && success.data.successCode == "200") {
                  $ctrl.$state.go('payment.success', {
                    orderId: $ctrl.$stateParams.orderId,
                    isCardSaved: true
                  });
                } else {
                  $ctrl.$state.go('payment.failure', {
                    orderId: $ctrl.$stateParams.orderId,
                    logString: JSON.stringify(success.data.additionalInfo),
                    reasonCode: success.data.successCode
                  });
                }
              });
            },

            onError: function (err) {
              $ctrl.$state.go('payment.failure', {
                orderId: $ctrl.$stateParams.orderId,
                logString: JSON.stringify(err)
                // reasonCode: error.data.successCode
              });
            }

          });


        // Only render if eligible
        if (btn.isEligible()) {
          setTimeout(() => {
            btn.render('#' + id + '-container');
          }, 1000);
        } else {
          // If not eligible, optionally hide or show a fallback message
          document.getElementById(id + '-container').innerHTML = '<p>Not eligible</p>';
        }
      }
    }
  }


  initializePaypal4(id, paypalLoadingTimes) {
    var $ctrl = this;
    this.$spinner.show('appSpinner');
    // console.log("paypal integration ----> ", window.paypal);

    if (window.paypal && window.paypal.Buttons) {

      if (window.paypal.FUNDING && window.paypal.Buttons) {
        var marks = window.paypal.Marks({
          fundingSource: window.paypal.FUNDING.PAYPAL
        });
        // Only render if eligible
        if (marks.isEligible()) {
          setTimeout(() => {
            marks.render('#' + id + '-marks');
          }, 1000);
        }

        var btn = window.paypal
          .Buttons({
            appSwitchWhenAvailable: true,
            style: {
              shape: "rect",
              layout: "vertical",
              color: "gold",
              label: "paypal",
              tagline: false
            },
            async createOrder() {
              var giftCardsRequest = [];
              angular.forEach($ctrl.giftCardDetails, function (item, key) {
                if (item.isCardVerified && item.amount > 0) {

                  $ctrl.$spinner.show('appSpinner');
                  var giftCards = {

                    "giftCard": item.cardNumber,
                    "amount": item.amount,
                    "pin": item.cvv
                  };

                  giftCardsRequest.push(giftCards);
                }
              });
              var giftCardData = {
                "getGiftCardPreAuthCardRequestList": giftCardsRequest
              };

              var dataRequest = {
                "orderId": $ctrl.$stateParams.orderId,
                "getGiftCardPreAuthRequest": giftCardData
              };

              if ($ctrl.isStoreCreditUsed) {
                dataRequest.storeCreditAmountToBeCharged = $ctrl.amountToBeChargedFromStoreCredit;
              } else {
                dataRequest.storeCreditAmountToBeCharged = 0.00;
              }

              dataRequest.saveVault = $ctrl.savePaypalVault;

              if($ctrl.storeFeatures.paypal.customerHasVault) {
                dataRequest.proceedingWithVault = true;
                dataRequest.payment_source = {};
              } else {
                dataRequest.proceedingWithVault = false;
              }

              if(dataRequest.proceedingWithVault) {
                await $ctrl.$order.paypalCreateOrder(dataRequest).then(success => {
                  $ctrl.$spinner.hide('appSpinner');
                    if (success != null && success.data != null && success.data.successCode == "200") {
                      $ctrl.$state.go('payment.success', {
                        orderId: $ctrl.$stateParams.orderId,
                        isCardSaved: true
                      });
                    } else {
                      $ctrl.$state.go('payment.failure', {
                        orderId: $ctrl.$stateParams.orderId,
                        logString: JSON.stringify(success.data.additionalInfo),
                        reasonCode: success.data.successCode
                      });
                    }
                    
                    return success.data.id;
                }).catch(error => {
                  $ctrl.$spinner.hide('appSpinner');
                });
              }
              else {
                const success = await $ctrl.$order.paypalCreateOrder(dataRequest);
                $ctrl.$spinner.hide('appSpinner');
                // console.log("Success info :", success.data.id);
                return success.data.id;
              }
            },

            async onApprove(data, actions) {
              // console.log("Inside OnApprove data ---", data);
              // console.log("Inside OnApprove actions ---", actions);
              var orderData = {
                paypalCreateOrderId: data.orderID,
                orderId: $ctrl.$stateParams.orderId
              };

              const success = await $ctrl.$order.paypalCaptureOrder(orderData).then(success => {
                if (success != null && success.data != null && success.data.successCode == "200") {
                  $ctrl.$state.go('payment.success', {
                    orderId: $ctrl.$stateParams.orderId,
                    isCardSaved: true
                  });
                } else {
                  $ctrl.$state.go('payment.failure', {
                    orderId: $ctrl.$stateParams.orderId,
                    logString: JSON.stringify(success.data.additionalInfo),
                    reasonCode: success.data.successCode
                  });
                }
              });
            },

            onError: function (err) {
              $ctrl.$spinner.hide('appSpinner');
              $ctrl.$state.go('payment.failure', {
                orderId: $ctrl.$stateParams.orderId,
                logString: JSON.stringify(err)
                // reasonCode: error.data.successCode
              });
            }

          });
        // Only render if eligible
        if (btn.isEligible()) {
          $ctrl.paymentMethods.push({
            "value": "payNow",
            "name": "Pay with PayPal",
            "logo": true,
            "cardLogo": false,
            "id": "paypal-now-btn-marks",
            "lastChoosen": false,
            "type": "unique",
            "disable": false,
            "order": 3
          });

          if ($ctrl.storeFeatures.paypal.hasVaultEnabled) {
            console.log("Check if this is needed");
            /*
            if ($ctrl.storeFeatures.paypal.customerHasVault) {
              $ctrl.paymentMethods.push({
                "value": "payVault",
                "name": "Pay with PayPal Vault",
                "logo": true,
                "cardLogo": false,
                "id": "paypal-now-btn-marks2",
                "lastChoosen": false,
                "type": "unique",
                "disable": false,
                "order": 4
              });

              var marks2 = window.paypal.Marks({
                fundingSource: window.paypal.FUNDING.PAYPAL
              });
              // Only render if eligible
              if (marks2.isEligible()) {
                setTimeout(() => {
                  marks2.render('#paypal-now-btn-marks2');
                }, 1000);
              }

            }
            */
          }

          setTimeout(() => {
            btn.render('#' + id + '-container');
            $ctrl.$spinner.hide('appSpinner');
          }, 1000);
        } else {
          $ctrl.$spinner.hide('appSpinner');
          // If not eligible, optionally hide or show a fallback message
          document.getElementById(id + '-container').innerHTML = '<p>Not eligible</p>';
        }
      } else {
        $ctrl.$spinner.hide('appSpinner');
        if (paypalLoadingTimes < 2) {
          console.log("Paypal initializing times : " + paypalLoadingTimes);
          this.initializePaypal4('paypal-now-btn', paypalLoadingTimes + 1);
        }
      }
    } else {
      $ctrl.$spinner.hide('appSpinner');
      if (paypalLoadingTimes < 2) {
        console.log("Paypal initializing times : " + paypalLoadingTimes);
        this.initializePaypal4('paypal-now-btn', paypalLoadingTimes + 1);
      }
    }
  }

  initializePaypal_regular(id, paypalLoadingTimes) {
    var $ctrl = this;
    this.$spinner.show('appSpinner');
    // console.log("paypal integration ----> ", window.paypal);
    this.paypalTextOnButton = "";
    if (window.paypal && window.paypal.Buttons) {

      this.paypalFundingSources = [
        window.paypal.FUNDING.PAYPAL,
        window.paypal.FUNDING.VENMO,
        window.paypal.FUNDING.PAYLATER,
        window.paypal.FUNDING.CARD
      ];

      this.paypalFundingSources_keyvalue = {
        'paypal':   {  textOnButton: "'PayPal'"},
        'venmo':    {  textOnButton: "'venmo'" },
        'paylater': {  textOnButton: "'Pay Later'"} 
      // add more if needed
      }; 

      if (window.paypal.FUNDING && window.paypal.Buttons) {
        var marks = window.paypal.Marks({
          fundingSource: window.paypal.FUNDING.PAYPAL
        });
        // Only render if eligible
        if (marks.isEligible()) {
          setTimeout(() => {
            marks.render('#' + id + '-marks');
          }, 1000);
        }

        var btn = window.paypal
          .Buttons({
            appSwitchWhenAvailable: false,
            style: {
              shape: "rect",
              layout: "vertical",
              color: "gold",
              label: "paypal",
              tagline: false
            },
            onCancel: function (data) {
              // console.log(data); 
              $ctrl.$spinner.hide('appSpinner');
              if($ctrl.isGuestProfile()) {
                $ctrl.$state.go('guestdelivery');
              } else {
                $ctrl.$state.go('delivery');
              }
            },
            onClick: function (data, actions) {
              // console.log("Funding source clicked:", data.fundingSource);
              switch (data.fundingSource) {
                case window.paypal.FUNDING.PAYPAL:
                  $ctrl.updateUserAction($ctrl.APP.ORDER.USER_ACTION.PAYPAL,$ctrl.getAppOrderId());
                  break;
                case window.paypal.FUNDING.VENMO:
                  $ctrl.updateUserAction($ctrl.APP.ORDER.USER_ACTION.VENMO,$ctrl.getAppOrderId());
                  break;
                case window.paypal.FUNDING.PAYLATER:
                  $ctrl.updateUserAction($ctrl.APP.ORDER.USER_ACTION.PAY_LATER,$ctrl.getAppOrderId());
                  break;
                default:
                  break;
              }
            },
            createOrder: function(data, actions) {
              var giftCardsRequest = [];
              $ctrl.$spinner.show('appSpinner');
              angular.forEach($ctrl.giftCardDetails, function (item, key) {
                if (item.isCardVerified && item.amount > 0) {
                  var giftCards = {

                    "giftCard": item.cardNumber,
                    "amount": item.amount,
                    "pin": item.cvv
                  };

                  giftCardsRequest.push(giftCards);
                }
              });
              var giftCardData = {
                "getGiftCardPreAuthCardRequestList": giftCardsRequest
              };

              var dataRequest = {
                "orderId": $ctrl.$stateParams.orderId,
                "getGiftCardPreAuthRequest": giftCardData
              };

              if ($ctrl.isStoreCreditUsed) {
                dataRequest.storeCreditAmountToBeCharged = $ctrl.amountToBeChargedFromStoreCredit;
              } else {
                dataRequest.storeCreditAmountToBeCharged = 0.00;
              }

              if($ctrl.profile.customer.isGuest) {
                dataRequest.saveVault = false;
              } else {
                dataRequest.saveVault = $ctrl.savePaypalVault;
              }

              

              if($ctrl.storeFeatures.paypal.customerHasVault) {
                dataRequest.proceedingWithVault = true;
                dataRequest.payment_source = {};
              } else {
                dataRequest.proceedingWithVault = false;
              }
              
              return $ctrl.$order.paypalCreateOrder(dataRequest).then(success => {
                  // console.log("Success info :", success.data.id);
                  $ctrl.$spinner.hide('appSpinner');
                  return success.data.id;
                }).catch(error => {
                  $ctrl.$spinner.hide('appSpinner');
                  return null;
                });
            },

            onApprove: function(data, actions) {
              // console.log("Inside OnApprove data ---", data);
              // console.log("Inside OnApprove actions ---", actions);
              $ctrl.$spinner.show('appSpinner');
              var orderData = {
                paypalCreateOrderId: data.orderID,
                orderId: $ctrl.$stateParams.orderId
              };

              return $ctrl.$order.paypalCaptureOrder(orderData).then(success => {
                $ctrl.$spinner.hide('appSpinner');
                if (success != null && success.data != null && success.data.successCode == "200") {
                  $ctrl.$state.go('payment.success', {
                    orderId: $ctrl.$stateParams.orderId,
                    isCardSaved: true
                  });
                } else {
                  $ctrl.$state.go('payment.failure', {
                    orderId: $ctrl.$stateParams.orderId,
                    logString: JSON.stringify(success.data.additionalInfo),
                    reasonCode: success.data.successCode
                  });
                }
              }).catch(error => {
                $ctrl.$spinner.hide('appSpinner');
                return null;
              });
            },

            onError: function (err) {
              $ctrl.$spinner.hide('appSpinner');
              $ctrl.$state.go('payment.failure', {
                orderId: $ctrl.$stateParams.orderId,
                logString: JSON.stringify(err)
                // reasonCode: error.data.successCode
              });
            }

          });
        // Only render if eligible 

        if (btn.isEligible()) {
          const eligibleFundingSources = this.paypalFundingSources.filter(funding =>
            window.paypal.Buttons({ funding }).isEligible()
          );
          // console.log(" -- eligibleFundingSources --", eligibleFundingSources);
          var tempText  = '';

          if(this.storeFeatures.paypal.customerHasVault){
            this.paypalTextOnButton = "'Pay Now'";
          }
          for(var i = 0; i<eligibleFundingSources.length; i++){
            if(this.paypalFundingSources_keyvalue[eligibleFundingSources[i]]) {
              tempText = this.paypalFundingSources_keyvalue[eligibleFundingSources[i]].textOnButton;
              if(this.paypalTextOnButton!=null && this.paypalTextOnButton.length>0) {
                this.paypalTextOnButton = this.paypalTextOnButton + " or " + tempText;
              } else {
                this.paypalTextOnButton =  tempText;
              }
            }
          }
          $ctrl.paymentMethods.push({
            "value": "payNow",
            "name": "Pay with PayPal",
            "logo": true,
            "cardLogo": false,
            "id": "paypal-now-btn-marks",
            "lastChoosen": false,
            "type": "unique",
            "disable": false,
            "order": 3
          });

          if ($ctrl.storeFeatures.paypal.hasVaultEnabled) {
            // console.log("Check if this is needed");
            /*
            if ($ctrl.storeFeatures.paypal.customerHasVault) {
              $ctrl.paymentMethods.push({
                "value": "payVault",
                "name": "Pay with PayPal Vault",
                "logo": true,
                "cardLogo": false,
                "id": "paypal-now-btn-marks2",
                "lastChoosen": false,
                "type": "unique",
                "disable": false,
                "order": 4
              });

              var marks2 = window.paypal.Marks({
                fundingSource: window.paypal.FUNDING.PAYPAL
              });
              // Only render if eligible
              if (marks2.isEligible()) {
                setTimeout(() => {
                  marks2.render('#paypal-now-btn-marks2');
                }, 1000);
              }

            }
            */
          }

          setTimeout(() => {
            btn.render('#' + id + '-container');
            $ctrl.$spinner.hide('appSpinner');
          }, 1000);
        } else {
          $ctrl.$spinner.hide('appSpinner');
          // If not eligible, optionally hide or show a fallback message
          document.getElementById(id + '-container').innerHTML = '<p>Not eligible</p>';
        }
      } else {
        $ctrl.$spinner.hide('appSpinner');
        if (paypalLoadingTimes < 2) {
          console.log("Paypal initializing times : " + paypalLoadingTimes);
          this.initializePaypal_regular('paypal-now-btn', paypalLoadingTimes + 1);
        }
      }
    } else {
      $ctrl.$spinner.hide('appSpinner');
      if (paypalLoadingTimes < 2) {
        console.log("Paypal initializing times : " + paypalLoadingTimes);
        this.initializePaypal_regular('paypal-now-btn', paypalLoadingTimes + 1);
      }
    }
  }

  initializePaypal_returnuser(id, paypalLoadingTimes) {
    var $ctrl = this;
    this.$spinner.show('appSpinner');
    // console.log("paypal integration return user----> ", window.paypal);

    if (window.paypal && window.paypal.Buttons) {

      if (window.paypal.FUNDING && window.paypal.Buttons) {
        var marks = window.paypal.Marks({
          fundingSource: window.paypal.FUNDING.PAYPAL
        });
        // Only render if eligible
        if (marks.isEligible()) {
          setTimeout(() => {
            marks.render('#' + id + '-marks');
          }, 1000);
        }

        var btn = window.paypal
          .Buttons({
            appSwitchWhenAvailable: true,
            style: {
              shape: "rect",
              layout: "vertical",
              color: "gold",
              label: "paypal",
              tagline: false
            },
            createOrder: function(data, actions) {
              var giftCardsRequest = [];
              angular.forEach($ctrl.giftCardDetails, function (item, key) {
                if (item.isCardVerified && item.amount > 0) {

                  $ctrl.$spinner.show('appSpinner');
                  var giftCards = {

                    "giftCard": item.cardNumber,
                    "amount": item.amount,
                    "pin": item.cvv
                  };

                  giftCardsRequest.push(giftCards);
                }
              });
              var giftCardData = {
                "getGiftCardPreAuthCardRequestList": giftCardsRequest
              };

              var dataRequest = {
                "orderId": $ctrl.$stateParams.orderId,
                "getGiftCardPreAuthRequest": giftCardData
              };

              if ($ctrl.isStoreCreditUsed) {
                dataRequest.storeCreditAmountToBeCharged = $ctrl.amountToBeChargedFromStoreCredit;
              } else {
                dataRequest.storeCreditAmountToBeCharged = 0.00;
              }

              dataRequest.saveVault = $ctrl.savePaypalVault;

              if($ctrl.storeFeatures.paypal.customerHasVault) {
                dataRequest.proceedingWithVault = true;
                dataRequest.payment_source = {};
              } else {
                dataRequest.proceedingWithVault = false;
              }
              
              return $ctrl.$order.paypalCreateOrderReturnUser(dataRequest).then(success => {
                if (success != null && success.data != null && success.data.successCode == "200") {
                  $ctrl.$state.go('payment.success', {
                    orderId: $ctrl.$stateParams.orderId,
                    isCardSaved: true
                  });
                } else {
                  $ctrl.$state.go('payment.failure', {
                    orderId: $ctrl.$stateParams.orderId,
                    logString: JSON.stringify(success.data.additionalInfo),
                    reasonCode: success.data.successCode
                  });
                }
                }).catch(error => {
                  return null;
                });
            },

            onApprove: function(data, actions) {
              // console.log("Inside OnApprove data ---", data);
              // console.log("Inside OnApprove actions ---", actions);
              var orderData = {
                paypalCreateOrderId: data.orderID,
                orderId: $ctrl.$stateParams.orderId
              };

              return $ctrl.$order.paypalCaptureOrder(orderData).then(success => {
                if (success != null && success.data != null && success.data.successCode == "200") {
                  $ctrl.$state.go('payment.success', {
                    orderId: $ctrl.$stateParams.orderId,
                    isCardSaved: true
                  });
                } else {
                  $ctrl.$state.go('payment.failure', {
                    orderId: $ctrl.$stateParams.orderId,
                    logString: JSON.stringify(success.data.additionalInfo),
                    reasonCode: success.data.successCode
                  });
                }
              }).catch(error => {
                return null;
              });
            },

            onError: function (err) {
              $ctrl.$spinner.hide('appSpinner');
              $ctrl.$state.go('payment.failure', {
                orderId: $ctrl.$stateParams.orderId,
                logString: JSON.stringify(err)
                // reasonCode: error.data.successCode
              });
            }

          });
        // Only render if eligible
        if (btn.isEligible()) {
          $ctrl.paymentMethods.push({
            "value": "payNow",
            "name": "Pay with PayPal",
            "logo": true,
            "cardLogo": false,
            "id": "paypal-now-btn-marks",
            "lastChoosen": false,
            "type": "unique",
            "disable": false,
            "order": 3
          });

          if ($ctrl.storeFeatures.paypal.hasVaultEnabled) {
            // console.log("Check if this is needed");
            /*
            if ($ctrl.storeFeatures.paypal.customerHasVault) {
              $ctrl.paymentMethods.push({
                "value": "payVault",
                "name": "Pay with PayPal Vault",
                "logo": true,
                "cardLogo": false,
                "id": "paypal-now-btn-marks2",
                "lastChoosen": false,
                "type": "unique",
                "disable": false,
                "order": 4
              });

              var marks2 = window.paypal.Marks({
                fundingSource: window.paypal.FUNDING.PAYPAL
              });
              // Only render if eligible
              if (marks2.isEligible()) {
                setTimeout(() => {
                  marks2.render('#paypal-now-btn-marks2');
                }, 1000);
              }

            }
            */
          }

          setTimeout(() => {
            btn.render('#' + id + '-container');
            $ctrl.$spinner.hide('appSpinner');
          }, 1000);
        } else {
          $ctrl.$spinner.hide('appSpinner');
          // If not eligible, optionally hide or show a fallback message
          document.getElementById(id + '-container').innerHTML = '<p>Not eligible</p>';
        }
      } else {
        $ctrl.$spinner.hide('appSpinner');
        if (paypalLoadingTimes < 2) {
          // console.log("Paypal initializing times : " + paypalLoadingTimes);
          this.initializePaypal_returnuser('paypal-now-btn', paypalLoadingTimes + 1);
        }
      }
    } else {
      $ctrl.$spinner.hide('appSpinner');
      if (paypalLoadingTimes < 2) {
        // console.log("Paypal initializing times : " + paypalLoadingTimes);
        this.initializePaypal_returnuser('paypal-now-btn', paypalLoadingTimes + 1);
      }
    }
  }


  isValidToProceed() {
    if (this.paypalAutorizationWrapper.isPaypalAuthorized) {
      this.$toaster.pop('success', 'Paypal has already authorised. Please proceed to pay now.');
      return false;
    } else {
      return true;
    }
  }

  scrollToPaynow() {
    var scrollToPaynow = document.getElementById("scroll-to-paynow");
    if (scrollToPaynow) {
      // console.log("Scrolling to pay now.");
      scrollToPaynow.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    }
    this.$toaster.pop('success', 'Please proceed to Pay Now');
  }
  getStoreCreditAmountToBeCharged() {
    this.amountToBeChargedFromStoreCredit = 0.00;
    if (this.getTotalGiftCardAddedAmount() > 0) {
      var amountminusgift = this.orderAmount - this.getTotalGiftCardAddedAmount();
      amountminusgift = this.getRoundoffValue(amountminusgift, this.toDecimalPlaces);

      if (this.storeCreditAmount >= amountminusgift) {
        this.amountToBeChargedFromStoreCredit = amountminusgift;
      } else {
        this.amountToBeChargedFromStoreCredit = this.getRoundoffValue(this.storeCreditAmount, this.toDecimalPlaces);
      }
    } else {
      if (this.storeCreditAmount > this.orderAmount) {
        this.amountToBeChargedFromStoreCredit = this.orderAmount;
      } else {
        this.amountToBeChargedFromStoreCredit = this.getRoundoffValue(this.storeCreditAmount, this.toDecimalPlaces);
      }
    }
  }

  isStoreCreditAmountTobeUsed() {

    if (this.isStoreCreditUsed) {
      if (this.getStoreCredit() > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }

  }

  getStoreCredit() {

    var amountminusgift = this.orderAmount - this.getTotalGiftCardAddedAmount();
    amountminusgift = this.getRoundoffValue(amountminusgift, this.toDecimalPlaces);
    if (this.isStoreCreditUsed && amountminusgift == 0) {
      this.isStoreCreditUsed = false;
      this.amountToBeChargedFromStoreCredit = 0.00;
      this.$toaster.pop('success', "Total amount is already covered.");
      return;
    }

    this.getStoreCreditAmountToBeCharged();

    if (this.isStoreCreditUsed) {

      this.setIsAllowToPayOnlyWithGiftCards();

      if (this.getTotalGiftCardAddedAmount() > 0) {
        if (this.storeCreditAmount >= amountminusgift) {
          this.choosePaymentMethod();
          return amountminusgift;
        } else {
          this.choosePaymentMethod();
          return this.getRoundoffValue(this.storeCreditAmount, this.toDecimalPlaces);
        }
      }

      if (this.storeCreditAmount > this.orderAmount) {

        if (!this.isAllowToPayOnlyWithGiftCards) {
          this.isAllowToPayWithStoreCreditOnly = true;
        } else {
          // If gift cards involved, then we can't pay with storeCredit only.. Gift card api will take care of store credit amount.
          this.isAllowToPayWithStoreCreditOnly = false;
        }
        this.choosePaymentMethod();
        return this.orderAmount;
      } else {
        this.isAllowToPayWithStoreCreditOnly = false;
        this.choosePaymentMethod();
        return this.getRoundoffValue(this.storeCreditAmount, this.toDecimalPlaces);
      }
    } else {
      this.amountToBeChargedFromStoreCredit = 0.00;
      this.setIsAllowToPayOnlyWithGiftCards();
      this.isAllowToPayWithStoreCreditOnly = false;
      this.choosePaymentMethod();
    }
    return 0;
  }

  setIsAllowToPayOnlyWithGiftCards() {
    if (this.getTotalGiftCardAddedAmount() > 0) {
      if (this.isStoreCreditUsed) {
        var giftsPlusStoreCredit = this.getRoundoffValue(
          (this.getTotalGiftCardAddedAmount() +
            this.getRoundoffValue(this.amountToBeChargedFromStoreCredit, this.toDecimalPlaces)),
          this.toDecimalPlaces);
        // console.log("this.orderAmount---", this.orderAmount);
        // console.log("giftsPlusStoreCredit---", giftsPlusStoreCredit);
        this.isAllowToPayOnlyWithGiftCards = (this.orderAmount == giftsPlusStoreCredit);
      } else {
        this.isAllowToPayOnlyWithGiftCards = (this.getTotalGiftCardAddedAmount() == this.orderAmount);
      }
    } else {
      this.isAllowToPayOnlyWithGiftCards = false;
    }
  }
  infoPopup() {
    document.getElementById('popupsavecard').style.display = 'block';
    setTimeout(() => {
      if (document.getElementById('popupsavecard').style.display === 'block' && this.showPopup === false) {
        this.hideinfoPopup();
      }
    }, 1000);
  }

  infoPopuponhover() {
    document.getElementById('popupsavecard').style.display = 'block';
    this.showPopup = true;
  }

  hideinfoPopup() {
    document.getElementById('popupsavecard').style.display = 'none';
    this.showPopup = false;
  }

  addCreditCardPopUp() {
    this.showAddCardButton = false;
    if (!this.hasCardInitializedAlready) {
      if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.tsys) {
        this.$spinner.show('appSpinner');
        setTimeout(() => {
          this.addTsysCreditCard(this.GlobalPayments);
        }, 100);
      } else if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.heartLand) {
        setTimeout(() => {
          this.addHeartlandCreditCard(this.Heartland);
        }, 100);
      } else if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.moneris) {
        setTimeout(() => {
          // this.paymentGlobalKey = success.data.globalKey;
          if (window.innerWidth < 768) {
            // console.log('inside mobile');
            document.getElementById("monerisFrameUpdate").src = this.gatewayUrl + "?id=" + this.paymentGlobalKey +
              "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;&display_labels=1&enable_exp=1&enable_cvd=1" +

              "&css_textbox=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" +
              "padding: 6px 12px;line-height: 1.42;" +
              "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px" +

              "&css_label_pan=;margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" +
              "&css_label_exp=;margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" +
              "&css_label_cvd=;margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif";
          } else {
            document.getElementById("monerisFrameUpdate").src = this.gatewayUrl + "?id=" + this.paymentGlobalKey +
              "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;&display_labels=1&enable_exp=1&enable_cvd=1" +

              "&css_textbox=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" +
              "padding: 6px 12px;line-height: 1.42;" +
              "margin-top: 5px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px" +

              "&css_label_pan=;margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" +
              "&css_label_exp=;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" +
              "&css_label_cvd=;margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif";
          }
          this.addMonerisCreditCard();
        }, 100);
      }
      this.hasCardInitializedAlready = true;
    }
  }


  addHeartlandCreditCard(Heartland) {
    var $ctrl = this;
    this.hps = new Heartland.HPS({
      publicKey: $ctrl.paymentGlobalKey,
      type: 'iframe',
      // Configure the iframe fields to tell the library where
      // the iframe should be inserted into the DOM and some
      // basic options
      fields: {
        cardNumber: {
          target: 'iframesCardNumber',
          placeholder: 'xxxx xxxx xxxx xxxx'
        },
        cardExpiration: {
          target: 'iframesCardExpiration',
          placeholder: 'MM / YYYY'
        },
        cardCvv: {
          target: 'iframesCardCvv',
          placeholder: 'CVV'
        },
        submit: {
          value: 'submit',
          target: 'iframesSubmit'
        }
      },
      // Collection of CSS to inject into the iframes.
      // These properties can match the site's styles
      // to create a seamless experience.
      style: {
        'input': {
          'background': '#fff',
          'border': '1px solid',
          'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
          'box-sizing': 'border-box',
          'font-family': 'serif',
          'font-size': '16px',
          'line-height': '1',
          'margin': '0 .5em 0 0',
          'max-width': '100%',
          'outline': '0',
          'padding': '0.5278em',
          'vertical-align': 'baseline',
          'height': '50px',
          'width': '100% !important'
        },
        '#heartland-field': {
          'font-family': 'sans-serif',
          'box-sizing': 'border-box',
          'display': 'block',
          'height': '50px',
          'padding': '6px 12px',
          'font-size': '14px',
          'line-height': '1.42857143',
          'color': '#555',
          'background-color': '#fff',
          'border': '1px solid #ccc',
          'border-radius': '0px',
          '-webkit-box-shadow': 'inset 0 1px 1px rgba(0,0,0,.075)',
          'box-shadow': 'inset 0 1px 1px rgba(0,0,0,.075)',
          '-webkit-transition': 'border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s',
          '-o-transition': 'border-color ease-in-out .15s,box-shadow ease-in-out .15s',
          'transition': 'border-color ease-in-out .15s,box-shadow ease-in-out .15s',
          'width': '100%'
        },
        '#heartland-field[name=submit]': {
          'background-color': '#a4182d',
          'font-family': 'sans-serif',
          'text-transform': 'uppercase',
          'color': '#ffffff',
          'border': '0px solid transparent',
          'width': '200px !important',
          'margin-left': '5px  !important'
        },
        '#heartland-field[name=submit]:focus': {
          'color': '#ffffff',
          'background-color': '#a4182d',
          'outline': 'none'
        },
        '#heartland-field[name=submit]:hover': {
          'background-color': ' #a4182d'
        },
        '#heartland-field-wrapper #heartland-field:focus': {
          'border': '1px solid #3989e3',
          'outline': 'none',
          'box-shadow': 'none',
          'height': '50px'
        },
        'heartland-field-wrapper #heartland-field': {
          'height': '50px'
        },
        'input[type=submit]': {
          'box-sizing': 'border-box',
          'display': 'inline-block',
          'padding': '6px 12px',
          'margin-bottom': '0',
          'font-size': '14px',
          'font-weight': '400',
          'line-height': '1.42857143',
          'text-align': 'center',
          'white-space': 'nowrap',
          'vertical-align': 'middle',
          '-ms-touch-action': 'manipulation',
          'touch-action': 'manipulation',
          'cursor': 'pointer',
          '-webkit-user-select': 'none',
          '-moz-user-select': 'none',
          '-ms-user-select': 'none',
          'user-select': 'none',
          'background-image': 'none',
          'border': '1px solid transparent',
          'border-radius': '4px',
          'color': '#fff',
          'background-color': '#a4182d',
          'border-color': '#2e6da4'
        },
        '#heartland-field[placeholder]': {
          'letter-spacing': '3px'
        },
        '#heartland-field[name=cardCvv]': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/cvv1.png?raw=true) no-repeat right',
          'background-size': '63px 40px'
        },
        'input#heartland-field[name=cardNumber]': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-inputcard-blank@2x.png?raw=true) no-repeat right',
          'background-size': '55px 35px'
        },
        '#heartland-field.invalid.card-type-visa': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-visa@2x.png?raw=true) no-repeat right',
          'background-size': '83px 88px',
          'background-position-y': '-44px'
        },
        '#heartland-field.valid.card-type-visa': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-visa@2x.png?raw=true) no-repeat right top',
          'background-size': '82px 86px'
        },
        '#heartland-field.invalid.card-type-discover': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-discover@2x.png?raw=true) no-repeat right',
          'background-size': '85px 90px',
          'background-position-y': '-44px'
        },
        '#heartland-field.valid.card-type-discover': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-discover@2x.png?raw=true) no-repeat right',
          'background-size': '85px 90px',
          'background-position-y': '1px'
        },
        '#heartland-field.invalid.card-type-amex': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-savedcards-amex@2x.png?raw=true) no-repeat right',
          'background-size': '50px 90px',
          'background-position-y': '-44px'
        },
        '#heartland-field.valid.card-type-amex': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-savedcards-amex@2x.png?raw=true) no-repeat right top',
          'background-size': '50px 90px'
        },
        '#heartland-field.invalid.card-type-mastercard': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-mastercard.png?raw=true) no-repeat right',
          'background-size': '62px 105px',
          'background-position-y': '-52px'
        },
        '#heartland-field.valid.card-type-mastercard': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-mastercard.png?raw=true) no-repeat right',
          'background-size': '62px 105px',
          'background-position-y': '-1px'
        },
        '#heartland-field.invalid.card-type-jcb': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-jcb@2x.png?raw=true) no-repeat right',
          'background-size': '55px 94px',
          'background-position-y': '-44px'
        },
        '#heartland-field.valid.card-type-jcb': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-jcb@2x.png?raw=true) no-repeat right top',
          'background-size': '55px 94px',
          'background-position-y': '2px'
        },
        'input#heartland-field[name=cardNumber]::-ms-clear': {
          'display': 'none'
        }
      },
      // Callback when a token is received from the service
      onTokenSuccess: function (resp) {
        // console.log('Received Token from Heartland : ', resp.token_value);
        $ctrl.$spinner.show('appSpinner');
        let dataReq = {
          "token": resp.token_value,
          // "isNewCard": true,
          "cardLast4": resp.last_four,
          "cardType": resp.card_type,
          "cardNumber": resp.card.number,
          "expiryMonth": resp.exp_month,
          "expiryYear": resp.exp_year
        };
        if (!$ctrl.hasErplyCardUpdateInitialized) {
          $ctrl.hasErplyCardUpdateInitialized = true;
          $ctrl.$order.updateCardHeartland(dataReq)
            .then(success => {
              $ctrl.hasErplyCardUpdateInitialized = false;
              $ctrl.clearIframeFields();
              $ctrl.showHeartLandPage = false;
              $ctrl.$spinner.hide('appSpinner');
              $ctrl.showAddCardButton = true;
              if (success.data.successCode === '00') {
                $ctrl.getSavedCards();
                $ctrl.$toaster.pop('success', 'Card Updated Successfully');
                //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
                // $ctrl.$state.go('cards-management', { 'success': 'success' });

              }
              else {
                //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
                // $ctrl.$state.go('cards-management', { 'success': 'Failure' });
                $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
                $ctrl.isCallingAPI = false;
              }
            },
              error => {
                $ctrl.showAddCardButton = true;
                $ctrl.hasErplyCardUpdateInitialized = false;
                $ctrl.clearIframeFields();
                $ctrl.$spinner.hide('appSpinner');
                $ctrl.showHeartLandPage = false;
                $ctrl.isCallingAPI = false;
                // $ctrl.$state.go('cards-management', { 'success': 'Failure' });
                //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
                $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
                // var myEl = angular.element( document.querySelector( '#credit-card' ) );
                // myEl.remove();
              }
            )
            .catch(err => {
              $ctrl.showAddCardButton = true;
              $ctrl.hasErplyCardUpdateInitialized = false;
              $ctrl.clearIframeFields();
              $ctrl.$spinner.hide('appSpinner');
              $ctrl.showHeartLandPage = false;
              $ctrl.isCallingAPI = false;
              // $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
              // $ctrl.$state.go('cards-management', { 'success': 'Failure' });
              $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
            });
        }
      },
      // Callback when an error is received from the service
      onTokenError: function (resp) {
        $ctrl.showAddCardButton = true;
        $ctrl.hasErplyCardUpdateInitialized = false;
        $ctrl.clearIframeFields();
        $ctrl.$spinner.hide('appSpinner');
        // console.log("Error - ", resp);
        $ctrl.showHeartLandPage = false;
        $ctrl.isCallingAPI = false;
        // $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
        // $ctrl.$state.go('cards-management', { 'success': 'Failure' });
        $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
      },
      // Callback when an event is fired within an iFrame
      onEvent: function (ev) {
        // console.log("HPS event:", ev);
      }
    });

    this.$onDestroy = function () {
      this.hps.dispose();
    };
  }



  addTsysCreditCard(GlobalPayments) {
    var $ctrl = this;
    GlobalPayments.configure({
      'X-GP-Api-Key': this.paymentGlobalKey,
      'X-GP-Environment': this.env,
      'enableAutocomplete': true
    });


    var cardForm = GlobalPayments.ui.form({
      type: 'iframe',
      fields: {
        "card-number": {
          target: "#card-number",
          placeholder: "xxxx xxxx xxxx xxxx"
        },
        "card-expiration": {
          target: "#card-expiration",
          placeholder: "MM / YYYY"
        },
        "card-cvv": {
          target: "#card-cvv",
          placeholder: "xxx"
        },
        "submit": {
          target: "#submit",
          text: "Submit"
        }
      },

      styles: {

        "input": {
          "outline": "none",
          "border-width": "0",
          "letter-spacing": "2px",
          "width": "20px",
          "height": "40px"
        },
        "input, select": {
          "padding": "5px 10px",
          "font-size": "13px",
          "background": "#f3faff",
          "border": "1px solid #e0f1ff",
          "box-sizing": "border-box",
          "width": "20px",
          "height": "40px"
        },
        "input:focus": {
          "-webkit-box-shadow": "inset 0px 0px 3px 0px #b0dcff !important",
          "box-shadow": "inset 0px 0px 3px 0px #b0dcff !important",
          "border-color": "#b0dcff !important",
          "width": "20px",
          "height": "40px"
        },
        "button": {
          "pointer-events": "none",
          "opacity": ".5",


          'box-sizing': 'border-box',
          'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
          'font-size': '15px',
          'line-height': '1',
          'width': 'auto !important',
          'outline': '0',
          'padding': '.5278em',
          'vertical-align': 'baseline',
          'height': '50px',
          'background-color': '#a4182d',
          'font-family': 'sans-serif',
          'text-transform': 'uppercase',
          'border': '0 solid transparent',
          'color': '#fff',
          // 'cursor': 'pointer',
          'flex': '0.61 1 auto !important'
        },
        "button:active": {
          "filter": "brightness(112%)",
          "text-align": "center"
        },
        ".card-number.card-type-visa": {
          "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-visa@2x.png) no-repeat right",
          "background-position-y": "0px",
          "background-size": "70px 75px",
          "width": "50px"
        },
        ".card-number.card-type-mastercard": {
          "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-mastercard@2x.png) no-repeat right",
          "background-position-y": "4px",
          "background-size": "60px 64px"
        },
        ".card-number.card-type-discover": {
          "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-discover@2x.png) no-repeat right",
          "background-position-y": "-5px",
          "background-size": "90px 96px"
        },
        ".card-number.card-type-jcb": {
          "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-jcb@2x.png) no-repeat right",
          "background-position-y": "0px",
          "background-size": "48px 82px"
        },
        ".card-number.card-type-amex": {
          "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-amex@2x.png) no-repeat right",
          "background-position-y": "-4px",
          "background-size": "55px 98px"
        }
      }
    });

    cardForm.on("token-success", resp => {
      // add a payment token to form as a hidden input
      // console.log("token-success", resp);
      const token = document.createElement("input");
      token.type = "hidden";
      token.name = "temporary_token";
      token.value = "resp.temporary_token";

      // submit temporary_token to backend, process with our gateway
      // const form = document.getElementById("payment-form");
      // form.appendChild(child);
      // form.submit;



      // console.log("Token Success", resp.temporary_token);
      $ctrl.$spinner.show('appSpinner');
      let dataReq = {
        "token": resp.temporary_token,
        // "isNewCard": true,
        "cardLast4": resp.last_four,
        "cardType": resp.card_type,
        "cardNumber": resp.card.number,
        "expiryMonth": resp.exp_month,
        "expiryYear": resp.exp_year
      };

      if (!$ctrl.hasErplyCardUpdateInitialized) {
        $ctrl.hasErplyCardUpdateInitialized = true;
        $ctrl.$order.updateCardTsys(dataReq)
          .then(success => {
            $ctrl.showAddCardButton = true;
            $ctrl.hasErplyCardUpdateInitialized = false;
            $ctrl.$spinner.hide('appSpinner');
            $ctrl.showHeartLandPage = false;
            $ctrl.$spinner.hide('appSpinner');
            if (success.data.successCode === '00') {
              $ctrl.getSavedCards();
              $ctrl.$toaster.pop('success', 'Card added Successfully');
              //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
              // $ctrl.$state.go('cards-management', { 'success': 'success' });

            }
            else {
              //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
              // $ctrl.$state.go('cards-management', { 'success': 'Failure' });
              $ctrl.$toaster.pop('success', 'Unable to add your card currently. Please try again later.');
              $ctrl.isCallingAPI = false;
            }
          },
            error => {
              $ctrl.showAddCardButton = true;
              $ctrl.hasErplyCardUpdateInitialized = false;
              $ctrl.clearIframeFields();
              $ctrl.$spinner.hide('appSpinner');
              $ctrl.showHeartLandPage = false;
              $ctrl.isCallingAPI = false;
              // $ctrl.$state.go('cards-management', { 'success': 'Failure' });
              //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
              $ctrl.$toaster.pop('success', 'Unable to add your card currently. Please try again later.');
              // var myEl = angular.element( document.querySelector( '#credit-card' ) );
              // myEl.remove();
            }
          )
          .catch(err => {
            $ctrl.showAddCardButton = true;
            $ctrl.hasErplyCardUpdateInitialized = false;
            $ctrl.clearIframeFields();
            $ctrl.$spinner.hide('appSpinner');
            $ctrl.showHeartLandPage = false;
            $ctrl.isCallingAPI = false;
            // $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
            // $ctrl.$state.go('cards-management', { 'success': 'Failure' });
            $ctrl.$toaster.pop('success', 'Unable to add your card currently. Please try again later.');
          }
          );
      }
    });

    cardForm.on("token-error", resp => {
      // console.log("token-error", resp);
      $ctrl.cardFailure();
    });

    GlobalPayments.on("error", error => {
      // console.log("error", error);
      $ctrl.cardFailure();
    });

    cardForm.on("card-number-test", function (resp) {
      $ctrl.cardvalid = resp.valid;
      $ctrl.submitButtonState(cardForm);
      // console.log("card-number-test", resp);
    });

    cardForm.on("card-expiration-test", resp => {
      //   console.log("card-expiration-test", resp);
      $ctrl.expdatevalid = resp.valid;
      $ctrl.submitButtonState(cardForm);
      // console.log("card-expiration-test", resp);
    });

    cardForm.on("card-cvv-test", resp => {
      $ctrl.cvvalid = resp.valid;
      $ctrl.submitButtonState(cardForm);
      // console.log("card-cvv-test", resp);
    });

    cardForm.ready(() => {
      // console.log("Registration of all credit card fields occurred");
      $ctrl.$spinner.hide('appSpinner');
    });

  }


  // Moneris
  addMonerisCreditCard() {
    var $ctrl = this;

    $ctrl.respUpdateMsg = function (e) {
      // console.log("RespUpdateMsg get called ", e);
      // var respData = eval("(" + e.data + ")");
      // var resCode = `${respData.responseCode}`;
      // var resDataKey = `${respData.dataKey}`;

      var parsingJson = JSON.parse(e.data);

      // console.log("Parsing Json : ",parsingJson);
      // console.log("dataKey : ",parsingJson.dataKey);
      // console.log("responseCode : ", parsingJson.responseCode);

      var resCode = parsingJson.responseCode;
      var resDataKey = parsingJson.dataKey;

      if (resCode != null) {
        //   resCode = resCode.split(',');
        // console.log("ResCode : ", resCode, " : ResCode length: ", resCode.length);
        if (resCode.length > 0) {
          if (resCode[0] == '001') {
            $ctrl.cardUpdateMoneris(resDataKey);
          } else {
            var srcLink = '';
            if (window.innerWidth < 768) {
              // console.log('inside mobile');
              srcLink = $ctrl.gatewayUrl + "?id=" + $ctrl.paymentGlobalKey +
                "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;;&display_labels=1&enable_exp=1&enable_cvd=1" +

                "&css_textbox=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" +
                "padding: 6px 12px;line-height: 1.42;" +
                "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px";

              if (resCode[0] == 943) {
                srcLink = srcLink + "&css_label_pan=margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" +
                  "&css_textbox_pan=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" +
                  "padding: 6px 12px;line-height: 1.42;" +
                  "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px" +
                  "&css_label_exp=;margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" +
                  "&css_label_cvd=;margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif";

              } else if (resCode[0] == 944) {
                srcLink = srcLink + "&css_label_pan=margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" +
                  "&css_label_exp=margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" +
                  "&css_label_cvd=margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" +
                  "&css_textbox_exp=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" +
                  "padding: 6px 12px;line-height: 1.42;" +
                  "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px";

              } else if (resCode[0] == 945) {
                srcLink = srcLink + "&css_label_pan=margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" +
                  "&css_label_exp=;margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" +
                  "&css_label_cvd=margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" +
                  "&css_textbox_cvd=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" +
                  "padding: 6px 12px;line-height: 1.42;" +
                  "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px";
              } else {
                // console.log("Moneris page not loaded due to : ", resCode[0], " check for https://developer.moneris.com/More/Testing/Response%20Codes");
                $ctrl.goBack();
              }
            } else {
              srcLink = $ctrl.gatewayUrl + "?id=" + $ctrl.paymentGlobalKey +
                "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;;&display_labels=1&enable_exp=1&enable_cvd=1" +
                // "&css_textbox_pan=width:250px;height: 35px;margin-bottom: 10px;margin-top: 5px" +
                // "&css_textbox_exp=width:250px;height: 35px;margin-bottom: 10px;margin-top: 5px" +
                // "&css_textbox_cvd=width:250px;height: 35px;margin-bottom: 10px;margin-top: 5px;" +
                // "&css_input_label=";
                "&css_textbox=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" +
                "padding: 6px 12px;line-height: 1.42;" +
                "margin-top: 5px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px";
              if (resCode[0] == 943) {
                srcLink = srcLink + "&css_label_pan=color:darkslategrey;margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;font-family: sans-serif" +
                  "&css_textbox_pan=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" +
                  "padding: 6px 12px;line-height: 1.42;" +
                  "margin-top: 5px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px" +
                  "&css_label_exp=;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" +
                  "&css_label_cvd=;margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif";

              } else if (resCode[0] == 944) {
                srcLink = srcLink + "&css_label_pan=margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" +
                  "&css_label_exp=color:darkslategrey;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;font-family: sans-serif" +
                  "&css_label_cvd=margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" +
                  "&css_textbox_exp=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" +
                  "padding: 6px 12px;line-height: 1.42;" +
                  "margin-top: 5px;margin-right: 10px;border: 1.5px solid red !important;border-radius: 0px";

              } else if (resCode[0] == 945) {
                srcLink = srcLink + "&css_label_pan=margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" +
                  "&css_label_exp=;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" +
                  "&css_label_cvd=color:darkslategrey;margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;font-family: sans-serif" +
                  "&css_textbox_cvd=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;" +
                  "padding: 6px 12px;line-height: 1.42;" +
                  "margin-top: 5px;margin-right: 10px;border: 1.5px solid red !important;border-radius: 0px";
              } else {
                console.log("Moneris page not loaded due to : ", resCode[0], " check for https://developer.moneris.com/More/Testing/Response%20Codes");
                $ctrl.goBack();
              }
            }
            document.getElementById("monerisFrameUpdate").src = srcLink;
          }
        }
      }
    };


    if (!this.APP.ORDER.MONERIS_LOADED.update_page_loaded) {
      this.APP.ORDER.MONERIS_LOADED.update_page_loaded = true;
      // console.log("Adding once this.respUpdateMsg : ", this.respUpdateMsg);
      if (window.addEventListener) {
        window.addEventListener("message", this.respUpdateMsg, false);
      }
      else {
        if (window.attachEvent) {
          window.attachEvent("onmessage", this.respUpdateMsg);
        }
      }
    }
  }

  clearIframeFields() {
    var heartlandcontenthtml = angular.element(document.querySelector('#heartlandcontent'));
    var iframesG = angular.element(document.querySelector('#iframes'));
    var cardNumberIframe = angular.element(document.querySelector('#iframesCardNumber'));
    var CardExpIframe = angular.element(document.querySelector('#iframesCardExpiration'));
    var CardCvvIframe = angular.element(document.querySelector('#iframesCardCvv'));
    var CardSubmitIframe = angular.element(document.querySelector('#iframesSubmit'));
  }

  cardFailure() {
    var $ctrl = this;
    $ctrl.showAddCardButton = true;
    $ctrl.hasErplyCardUpdateInitialized = false;
    $ctrl.clearIframeFields();
    $ctrl.$spinner.hide('appSpinner');
    $ctrl.showHeartLandPage = false;
    $ctrl.isCallingAPI = false;
    $ctrl.$toaster.pop('success', 'Unable to add your card currently. Please try again later.');
  }

  submitButtonState(cardForm) {
    var $ctrl = this;
    // console.log("cardForm := ",cardForm);
    // console.log($ctrl.cardvalid + ", " + $ctrl.expdatevalid + ", " + $ctrl.cvvalid);
    if (($ctrl.cvvalid && $ctrl.cardvalid && $ctrl.expdatevalid)) {
      cardForm.addStylesheet({
        "button": {
          "pointer-events": "auto",
          "opacity": "1",

          'box-sizing': 'border-box',
          'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
          'font-size': '15px',
          'line-height': '1',
          'width': 'auto !important',
          'outline': '0',
          'padding': '.5278em',
          'vertical-align': 'baseline',
          'height': '50px',
          'background-color': '#a4182d',
          'font-family': 'sans-serif',
          'text-transform': 'uppercase',
          'border': '0 solid transparent',
          'color': '#fff',
          'cursor': 'pointer',
          'flex': '0.61 1 auto !important'
        }
      });
    } else {
      cardForm.addStylesheet({
        "button": {
          "pointer-events": "none",
          "opacity": ".5",


          'box-sizing': 'border-box',
          'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
          'font-size': '15px',
          'line-height': '1',
          'width': 'auto !important',
          'outline': '0',
          'padding': '.5278em',
          'vertical-align': 'baseline',
          'height': '50px',
          'background-color': '#a4182d',
          'font-family': 'sans-serif',
          'text-transform': 'uppercase',
          'border': '0 solid transparent',
          'color': '#fff',
          // 'cursor': 'pointer',
          'flex': '0.61 1 auto !important'
        }
      });
    }
  }


  cardUpdateMoneris(token) {
    var $ctrl = this;
    if (!this.hasPaymentInitialized) {
      this.hasPaymentInitialized = true;
      $ctrl.$spinner.show('appSpinner');
      console.log("Adding moneris card");

      let dataReq = {
        "token": token,
        "action": "update",
        // "isNewCard": true,
        // "cardLast4": resp.last_four,
        // "cardType": resp.card_type,
        // "cardNumber": resp.card.number,
        // "expiryMonth": resp.exp_month,
        // "expiryYear": resp.exp_year,
        "cardId": $ctrl.updateCardId
      };


      $ctrl.$order.updateCardMoneris(dataReq)
        .then(success => {
          $ctrl.showAddCardButton = true;
          $ctrl.hasPaymentInitialized = false;
          $ctrl.$spinner.hide('appSpinner');
          $ctrl.showHeartLandPage = false;
          $ctrl.hasErplyCardUpdateInitialized = false;
          if (success.data.successCode === '00') {
            $ctrl.getSavedCards();
            $ctrl.$toaster.pop('success', 'Card Updated Successfully');
            // $ctrl.$state.go('cards-management', { 'success': 'success' });

          }
          else {
            // $ctrl.$state.go('cards-management', { 'success': 'Failure' });
            $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
            $ctrl.isCallingAPI = false;
          }
        },
          error => {
            $ctrl.showAddCardButton = true;
            $ctrl.hasErplyCardUpdateInitialized = false;
            $ctrl.clearIframeFields();
            $ctrl.$spinner.hide('appSpinner');
            $ctrl.showHeartLandPage = false;
            $ctrl.isCallingAPI = false;
            // $ctrl.$state.go('cards-management', { 'success': 'Failure' });
            $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
          }
        )
        .catch(err => {
          $ctrl.showAddCardButton = true;
          $ctrl.hasErplyCardUpdateInitialized = false;
          $ctrl.clearIframeFields();
          $ctrl.$spinner.hide('appSpinner');
          $ctrl.showHeartLandPage = false;
          $ctrl.isCallingAPI = false;
          // $ctrl.$state.go('cards-management', { 'success': 'Failure' });
          $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
        });
    } else {
      console.log(" Moneris Payment already iniitalized");
    }
  }

  doMonerisSubmit() {
    this.$spinner.show('appSpinner');
    var monFrameRef = document.getElementById('monerisFrameUpdate').contentWindow;
    console.log("monFrameRef : ", monFrameRef);
    monFrameRef.postMessage('tokenize', this.gatewayUrl);
    this.$spinner.hide('appSpinner');
    return false;
  }

  goBack() {
    this.showAddCardButton = true;
  }

  getSavedCards() {
    this.$order.getPaymentInfo()
      .then(success => {
        if (success.data.length > 0) {
          console.log("---success.data.length---", success.data.length, success);
          this.cardId = success.data[success.data.length - 1].id;
        }
      })
      .catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      })
      .finally(() => {
      }
      );
  }

  choosePaymentMethod() {
    if (this.addMiscellaneousPaymentMethod) {
      if (this.isAllowToPayOnlyWithGiftCards || this.isAllowToPayWithStoreCreditOnly) {
        var miscellaneousExists = false;
        for (var i = 0; i < this.paymentMethods.length; i++) {
          if (this.paymentMethods[i].type == this.miscellaneous) {
            miscellaneousExists = true;
            this.paymentOption = this.paymentMethods[i].value;
          } else {
            this.paymentMethods[i].disable = true;
          }
        }
        if (!miscellaneousExists) {
          var newObj = {
            "name": "Pay with debit or credit card",
            "logo": false,
            "cardLogo": false,
            "id": "unsual-pay-now",
            "type": this.miscellaneous,
            "disable": false
          };
          if (this.isAllowToPayOnlyWithGiftCards) {
            newObj.value = "giftCard";
            newObj.name = "Pay with Gift Card";
          }
          if (this.isAllowToPayWithStoreCreditOnly) {
            newObj.value = "storeCredit";
            newObj.name = "Pay with Store Credit";
          }
          this.paymentOption = newObj.value;
          newObj.order = 5;
          this.paymentMethods.push(newObj);
        }
      } else {
        var removingIndex = null;
        var lastChoosenPaymentOption = "";
        for (var j = 0; j < this.paymentMethods.length; j++) {
          if (this.paymentMethods[j].type == this.miscellaneous) {
            removingIndex = j;
          } else {
            this.paymentMethods[j].disable = false;
            if (this.paymentMethods[j].lastChoosen) {
              lastChoosenPaymentOption = this.paymentMethods[j].value;
            }
          }
        }
        if (removingIndex != null) {
          this.paymentMethods.splice(removingIndex, 1);
          this.paymentOption = lastChoosenPaymentOption;
        }
      }
    }


    switch (this.paymentOption) {
      case this.paymentMethod.paypal.payNow:
        if (this.isAllowToPayOnlyWithGiftCards || this.isAllowToPayWithStoreCreditOnly) {
          this.showPlaceOrderButton = true;
          this.payWithNewCardButton = false;
          this.payWithSavedCardButton = false;
          this.payWithPayPalButton = false;
          this.payWithPayPalVaultButton = false;
          this.textOnButton = "Pay Now";
          this.textOnTerms = "'Pay Now'";
        } else {
          this.showPlaceOrderButton = false;
          this.payWithNewCardButton = false;
          this.payWithSavedCardButton = false;
          if(this.paypalTextOnButton!=null && this.paypalTextOnButton.length>0){
            this.textOnTerms = this.paypalTextOnButton;
          } else {
            this.textOnTerms = "'Pay Now' or 'PayPal' or 'venmo' or 'Pay Later'";
          }
          this.payWithPayPalButton = true;
          this.payWithPayPalVaultButton = false;
          
        }
        break;

      case this.paymentMethod.paypal.payVault:
        if (this.isAllowToPayOnlyWithGiftCards || this.isAllowToPayWithStoreCreditOnly) {
          this.showPlaceOrderButton = true;
          this.payWithNewCardButton = false;
          this.payWithSavedCardButton = false;
          this.payWithPayPalButton = false;
          this.payWithPayPalVaultButton = false;
          this.textOnButton = "Pay Now";
          this.textOnTerms = "'Pay Now'";
        } else {
          this.showPlaceOrderButton = false;
          this.payWithNewCardButton = false;
          this.payWithSavedCardButton = false;
          this.textOnButton = "Pay Now";
          this.textOnTerms = "'Pay Now'";
          this.payWithPayPalButton = false;
          this.payWithPayPalVaultButton = true;
        }
        break;

      case this.paymentMethod.creditCard.savedCard:
        this.showPlaceOrderButton = true;
        this.payWithSavedCardButton = true;
        this.payWithNewCardButton = false;
        this.payWithPayPalButton = false;
        this.payWithPayPalVaultButton = false;
        this.textOnButton = "Pay Now";
        this.textOnTerms = "'Pay Now'";
        break;

      case this.paymentMethod.creditCard.newCard:
        this.payWithPayPalButton = false;
        this.payWithPayPalVaultButton = false;
        this.payWithSavedCardButton = false;
        this.textOnButton = "Proceed to enter card details";
        this.textOnTerms = "'Proceed to enter card details'";
        if (this.isAllowToPayOnlyWithGiftCards || this.isAllowToPayWithStoreCreditOnly) {
          this.showPlaceOrderButton = true;
          this.payWithNewCardButton = false;
        } else {
          this.payWithNewCardButton = true;
          this.showPlaceOrderButton = false;
        }
        break;

      case this.paymentMethod.storeCredit:
        this.payWithNewCardButton = false;
        this.payWithSavedCardButton = false;
        this.showPlaceOrderButton = true;
        this.payWithPayPalButton = false;
        this.payWithPayPalVaultButton = false;
        this.textOnButton = "Pay Now";
        this.textOnTerms = "'Pay Now'";
        break;

      case this.paymentMethod.giftCard:
        this.payWithNewCardButton = false;
        this.payWithSavedCardButton = false;
        this.showPlaceOrderButton = true;
        this.payWithPayPalButton = false;
        this.payWithPayPalVaultButton = false;
        this.textOnButton = "Pay Now";
        this.textOnTerms = "'Pay Now'";
        break;

      default:
        this.payWithNewCardButton = true;
        this.payWithSavedCardButton = false;
        this.showPlaceOrderButton = false;
        this.payWithPayPalButton = false;
        this.payWithPayPalVaultButton = false;
        this.textOnButton = "Pay Now";
        this.textOnTerms = "'Pay Now'";
        break;
    }
  }

  updateUserAction(userAction,comments){
    this.$order.updateUserAction(userAction,comments);
  }

  getAppOrderId() {
    return this.$stateParams.orderId;
  }

}


// WEBPACK FOOTER //
// ./src/app/order/payment/card-detail.js